<template>
    <header :class="{showHeaderMobile123: currentRoute.name === 'SignUp' || currentRoute.name === 'Gift' || currentRoute.name === 'Gifts' || currentRoute.name === 'Redeem,' || currentRoute.name === 'Event' || currentRoute.name === 'AccentureCharlotte' || currentRoute.name === 'CorporationGifting' || currentRoute.name === 'CorporationGiftingComcast' || currentRoute.name === 'CorporationReferral'}" v-bind:style="{ backgroundColor: getCorpHeaderColor} + ' !important'">
        <a @click="headerMenusClick('/contactus')" style="cursor: pointer" class="fixed-fab-btn logged" v-if="currentRoute.name !== 'Feedback' &&  currentRoute.name !== 'Maintainance' && isUserLoggedIn">
            Tell us what you think
        </a>
<!--        Regular User Banner Bases on Gifting Status (Enabled)-->
        <span v-if="!isNativeApp && (user && user.corporation == null) && showGiftingLinks">
            <a @click="headerMenusClick('/gifts')" style="cursor: pointer" title="Gifts" class="giftslink" v-if="currentRoute.name !== 'Gift' && currentRoute.name !== 'Gifts' && currentRoute.name !== 'Redeem,' && currentRoute.name !== 'SignUp' && currentRoute.name !== 'AccentureCharlotte' && currentRoute.name !== 'TrialExpiry'&& currentRoute.name !== 'InterestList' && currentRoute.name !== 'CorporationGifting' && currentRoute.name !== 'CorporationGiftingComcast' && currentRoute.name !== 'CorporationReferral' && currentRoute.name !== 'Maintainance'"><i class="fa fa-gift"><span>{{getGiftingText}}</span></i></a>
        </span>
<!--        Regular User Banner Based on Gifting Status (Disabled) and Custom Messaging Enabled-->
        <div class="cust-corp-banner" v-if="!isNativeApp && (user && user.corporation == null) && !showGiftingLinks && getAuthLeftTopBannerMessage && currentRoute.path != getAuthLeftTopBannerUrl">
            <span v-if="!getAuthLeftTopBannerUrl || getAuthLeftTopBannerUrl.length < 3">
                {{getAuthLeftTopBannerMessage}}
            </span>
            <span v-else>
                 <a v-if="getAuthLeftTopBannerUrl" @click="corpBannerRedirect(getAuthLeftTopBannerUrl)" style="cursor: pointer" :title="getAuthLeftTopBannerUrl">{{getAuthLeftTopBannerMessage}}</a>
            </span>
        </div>
        <span v-if="!isNativeApp && (user && user.corporation && user.corporation.giftIconState === 1) && showGiftingLinks">
            <a @click="headerMenusClick('/gifts')" style="cursor: pointer" title="Gifts" class="giftslink" v-if="currentRoute.name !== 'Gift' && currentRoute.name !== 'Gifts' && currentRoute.name !== 'Redeem,' && currentRoute.name !== 'SignUp' && currentRoute.name !== 'AccentureCharlotte' && currentRoute.name !== 'TrialExpiry'&& currentRoute.name !== 'InterestList' && currentRoute.name !== 'CorporationGifting' && currentRoute.name !== 'CorporationGiftingComcast' && currentRoute.name !== 'CorporationReferral' && currentRoute.name !== 'Maintainance'"><i class="fa fa-gift"><span>{{getGiftingText}}</span></i></a>
        </span>
        <span v-if="!isNativeApp && (user && user.corporation && user.corporation.giftIconState === 2) && showGiftingLinks">
<!--            <a @click="headerMenusClick('/gifts')" style="cursor: pointer" title="Gifts" class="giftslink" v-if="currentRoute.name !== 'Gift' && currentRoute.name !== 'Gifts' && currentRoute.name !== 'Redeem,' && currentRoute.name !== 'SignUp' && currentRoute.name !== 'AccentureCharlotte' && currentRoute.name !== 'TrialExpiry'&& currentRoute.name !== 'InterestList' && currentRoute.name !== 'CorporationGifting' && currentRoute.name !== 'CorporationReferral' && currentRoute.name !== 'Maintainance'"><i class="fa fa-gift"><span>{{getGiftingText}}</span></i></a>-->
        </span>
<!--        Custom Banner for Corp Users (if enabled and Gifting is disabled)-->
        <div class="cust-corp-banner" v-if="!isNativeApp && (user && user.corporation && user.corporation.giftIconState === 3)">
            <span v-if="!user.corporation.giftIconUrl">
                {{user.corporation.giftIconMessage}}
            </span>
            <span v-else>
                 <a v-if="user.corporation.giftIconMessage" @click="corpBannerRedirect(user.corporation.giftIconUrl)" style="cursor: pointer" :title="user.corporation.giftIconMessage">{{user.corporation.giftIconMessage}}</a>
            </span>
        </div>

        <!--<a v-if="currentRoute.name !== 'Feedback' && isUserLoggedIn" class="fixed-fab-btn" href="#/feedback">Tell us what you think</a>-->
        <div class="logo">
            <a @click="logoClickRedirect" style="cursor: pointer">
                <img src="../../assets/logo.svg" alt="TONE LOGO">
            </a>
        </div>
        <!--Custom Banner is enabled-->
        <div class="notificationtext" v-if="getCustomUnauthBannerStatus && (currentRoute.name === 'UnAuth' && currentRoute.name !== 'Maintainance') && !hideBanner">
            <a href="javascript:" @click="$router.push(getCustomUnauthBannerLink)">{{getCustomUnauthBannerText}}</a> <a href="javascript:" class="close" @click="hideBanner=true">x</a>
        </div>
        <!--Custom Banner is disabled-->
        <div class="notificationtext" v-if="getBannerEvent > 0 && !getCustomUnauthBannerStatus && (currentRoute.name === 'UnAuth' && currentRoute.name !== 'Maintainance') && !hideBanner">
            <a href="javascript:" @click="$router.push('/event')">{{eventDescription}}</a> <a href="javascript:" class="close" @click="hideBanner=true">x</a>
        </div>
        <!-- Event Banner for regular users -->
        <div class="notificationtext" v-if="getBannerEvent > 0 && (currentRoute.name !== 'UnAuth' && currentRoute.name !== 'Event' && currentRoute.name !== 'Rules' && currentRoute.name !== 'Events' && currentRoute.name !== 'Talk' && currentRoute.name !== 'LiveEvent') && user && user.corporation == null">
            <a v-if="currentRoute.name !== 'Maintainance'" href="javascript:" @click="JoinEventOrRedirect">{{authEventDescription}}</a>
        </div>
        <span v-if="user && user.corporation && user.corporation.corporationId > 0 && user.corporation.enableCorporatePage === 1">
        <!-- Event Banner for corporation users whose custom page is disabled-->
        <div class="notificationtext" v-if="getBannerEvent > 0 && (currentRoute.name !== 'UnAuth' && currentRoute.name !== 'Event' && currentRoute.name !== 'Rules' && currentRoute.name !== 'Events' && currentRoute.name !== 'Talk' && currentRoute.name !== 'LiveEvent') && (user && user.corporation && user.corporation.corporationId > 0 && user.corporation.enableCorporatePage === 0)">
            <a v-if="currentRoute.name !== 'Maintainance'" href="javascript:" @click="JoinEventOrRedirect">{{authEventDescription}}</a>
        </div>
        <!-- Event Banner for corporation users whose custom page is enabled and event default to public event-->
        <div class="notificationtext" v-if="getBannerEvent > 0 && (currentRoute.name !== 'UnAuth' && currentRoute.name !== 'Event' && currentRoute.name !== 'Rules' && currentRoute.name !== 'Events' && currentRoute.name !== 'Talk' && currentRoute.name !== 'LiveEvent') && (user && user.corporation && user.corporation.corporationId > 0 && user.corporation.enableCorporatePage === 1 && user.corporation.bnrLinkState === 1)">
            <a v-if="currentRoute.name !== 'Maintainance'" href="javascript:" @click="JoinEventOrRedirect">{{authEventDescription}}</a>
        </div>
        <!-- Event Banner for corporation users whose custom page is enabled and event default to public event-->
        <div class="notificationtext" v-if="getBannerEvent > 0 && (currentRoute.name !== 'UnAuth' && currentRoute.name !== 'Event' && currentRoute.name !== 'Rules' && currentRoute.name !== 'Events' && currentRoute.name !== 'Talk' && currentRoute.name !== 'LiveEvent') && (user && user.corporation && user.corporation.corporationId > 0 && user.corporation.enableCorporatePage === 1 && user.corporation.bnrLinkState === 2)">
            <a v-if="currentRoute.name !== 'Maintainance'" href="javascript:" @click="$router.push('/corporation/mycommunity')">{{user.corporation.corpEvent.authBannerText}}</a>
        </div>
        <!-- Event Banner for corporation users whose custom page is enabled and event default to custom page-->
        <div class="notificationtext" v-if="getBannerEvent > 0 && (currentRoute.name !== 'UnAuth' && currentRoute.path != user.corporation.bnrCustomMsgUrl && (user && user.corporation && user.corporation.corporationId > 0 && user.corporation.enableCorporatePage === 1 && user.corporation.bnrLinkState === 3))">
            <a v-if="currentRoute.name !== 'Maintainance'" href="javascript:" @click="$router.push(user.corporation.bnrCustomMsgUrl)">{{user.corporation.bnrCustomMsg}}</a>
        </div>
            </span>
        <div class="nav-container" v-show='!isNav'>
            <div class="container">
                <div class="row">
                    <nav class="navbar" :class="[isUserLoggedIn ? 'static-min-height' : 'default-min-height']" v-bind:style="[isMobile ? {'backgroundColor': getCorpHeaderColor} : {}]" >
                        <div class="container-fluid">
                            <div class="row">
                                <div class="navbar-header">
                                    <button v-if="!isNativeAppNavigation"  type="button" class="pull-left navbar-toggle collapsed" data-toggle="collapse" data-target="#header-navbar">
                                        <span class="sr-only">Toggle navigation</span>
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                        <span class="icon-bar"></span>
                                    </button>
                                    <!--///////////////////////////////////-->
                                    <svg class="mobile-version" width="172px" height="69px" viewBox="0 0 172 69" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <defs></defs>
                                        <g id="Design-Round-5" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <g id="01_Tone_Home_1200_PINK" transform="translate(-514.000000, -33.000000)">
                                                <g id="Main-Nav">
                                                    <g id="Mast-Head">
                                                        <a @click="logoClickRedirect">
                                                            <image id="Logo" x="514" y="33" width="171.952381" height="69" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVgAAACKCAYAAADv7VLQAAAABGdBTUEAA1teXP8meAAAOShJREFUeAHtnQe8XUW1h6WHGloIxPQECL33FjpIERAUEJCiAlYsiMpTQX2oiOITn4iolIeiKChgCQgECCVC6CUQUkgIgQiEGnp533ez53py7yl7n3vOPvueO//f739nn71nz6xZs2bNmtn7nLvI+5qA9957rx/FfhK+A89fZJFF3mxCNbHIqIGogaiBvqUBnOsi8FB4O7wOjuxbGoitjRqIGogaWKCBRZugiB0o83i4NFwFrgojogaiBqIG+pwGFm9ki4lWB1LeUXBF+DZcJCFJRNRA1EDUQN/SQMMiWJyrZX0Ubg7dew0oPQ7nYho1EDUQNdD2GmiYg0VTG8D94HtdtGYkGxE1EDUQNdDnNNAQB0v0ugaa860BtwZCxOr2gMfvwoiogaiBqIE+p4EeO1ic62Jo7Ui4HQzONShS5xodbNBGTKMGogb6lAZ67GDR1pZwH1jOkcYItk+ZU2xs1EDUQKkGeuRgiV7XorBPQ7cGyjnYGMGWajseRw1EDfQpDdTtYHGuy6GpE+G68K0yWot7sGWUEk9FDUQN9B0N1OVgca5LoqJj4VjY9a0BTnUiRrCdqogHUQNRA31NA5kdLM7VyPTwhDrX6GD7mtXE9kYNRA2k0kBmB0upu8Ej4FKw3L4rpzvhO7C18nRmjgdRA1EDUQPtpIFMX5UlevVbWidDf18gzRcI4hZBO1lLm7QFO9Z++8N5/NLb823SrNiMAmogdQSLUW6C/CfB1WAa5xofchWww/uySNjwKtB3tn8Pb4Vn89mHtRFRA03RQKoIFiPckNq/AUfANM41CJtbBIuMtmVTaHQygcjk5SBEb01pk6+/LQN1Am7JLAFtp5OXcP/bNzjegK/DVyRtf5U0ItEAehzG4YHwCKgtq0dxMDwb3ueHRoN67Tfp7yP7YNiAxjHh++GdfUZ/2XcRdWoAPatfx4q6dryoa78AJRwj/h61+p4PX4IvovNqz47I0hjUdLAIP4qqvgxNy72OVU0SDUk2Fci4PBUcBh1AGvFx8FHYa0AblNufd/Td4jXhILgG1HBWgqUDNThYB6uD8zXohPIsnEdZT5LOgupgGsbUJ3/wHD2sQPuPgtrFVrAr1LkDsiGgPvvFPtsMOl6GwJWh9unPdy4GHQ+OIwe7fI775pDOhPfCOfRXliCGW/oe0Jljwslyffh+6HjxXAhKgm9zjDg+1LXbQc/AOdw/hfQR+Fgzx0cQgnq6AyEU/kvQNKtztUAbtxjllEZdnu8JNFKjOffQNN6N4PZwY+h5FTcPFh7oxYE3Bq4Djb6NtGyXNMpylpXqUYTPpgHO3uG3d0dwrNMwv1Gss/XT1KMhTYJTMCYdb1uD9g6mgR+BB8ItoBFNOagnB16PQH0DKWBruB10gnQbTcetwy3XZ54XpqX9pd3OoryJpHfCPjs50vZuQC860Q2g490xMwA6ieoT7MtSXYcxw+mO8WF/2C/ep94dHy/CmZTr2JAPMD7q8XPcWh6ho7tdpVId1qlQg6mnUsvWeB3cb8KKdXEtC1SmA8aZyu0AnZGKNTLQWH+Lks4iLSTQq5ONEepOcHO4NtRIhO0IhqK+bI9pIIcdeUIa8pcak9dE1/vtg9nwXjge3o+eXiBtG6Bb9XoAPBxunKJhRv2boYfHUuTtloX6hnHS+raFo6F9a59oi6ZZEPrLPhdz4b3wL/AeZDQK63NAx+pjFNwN7gqHwxB8lI4V9VeKcK30XOlxqb49dnK7G14Hb0LfPZ54KadjEJouBBrlbPwFqHPVWOqFgmt0zUBQYHAu1qURnoxybm9GhT0tE71uSBk7wz2gUY+6CYPRiSMMrrc5fh46yIxCdQQ6SAeteYzUjX6dXJyVV4SeVwfqo1yfeS2U/wrH98Ar4J2NMibKagnQ6/pUvBc8Eq4H1WUaqOMtaf/UNJlDHupT93vDg6BjRL2GfuSwIbAN9tlz8EZ4CXLOIO0zQM8u+feHrkQGwzBe1LcMk5mRqHSMqLOlofcul3wm6eif4Cv83BWWp851rNfDy9G3E1yPoDCdoEF+3hWeDHUADvTeApVzHTwdxehACgF0qlybwH3gLtCOdzCGCcKOVe9PQwe6s+iD8N9Qo3mN9rxBuhAoVyNy2bMCXB3qWLaAw6F9Z/mVDMo6NVYnpMnwD/BW6tGZFx6JTkch6PbQyWostM1Z8Sw3bE27p6W5kXqXJJ/R6pFwU2i/2ZdZo1VuSY3QV09wx5/hH5FXu2hboGcDiA/Ag+G6MOjZVH08BV0ZT4IPQfXhkl9/ZR77aVk4CDoutoTaixNjrf6yfMesZarvS9G3Y7MuKEwHaJTHzsqfgoOhwvYWKLvO5BsoY1xRhEan/ZFlP/hR6MOPUqdnJwqN5Q54DXQp+DppXaA+ne1GcHeos9XxCo2qHNSbjlbHej10e6Wu5TL3NhW0zUFje2yXD5H2hJvAThvmOCtSO1jqd0I7DB4JV4K1BipZGgrtxTF5Ffw5/WRk23ZAz67IdKxHwGVg0LPbAvPgv+CV8C50YMRaE0mZTowfgI4PHXgt/6a+Ha+3QfVtIJIZHcaJAFb4EXgi7AdtVG+CTmIK/BSKcNC0FOjTztkJHgU3gM6KpTr1urPiP+Ef4WzkblgURP3WNxTuD/eFq0LLr1RHmLWfJM9F8BrkeYG0ZaANbnusDdeEDgqjkOHQqMT+bgRSOVhkGUNlR8M9kkodeK2A49W23w7Po4/uaYUQzaoTPTthfgGun9Shnm2zvBueC++j3bWcI9m6g/KNareDh8MNYbUxweWOetX3bHgmvIW6S8cxp6rDf7FtAR+Hx0CjhEwFkL8IsA3/R+N/1Gph0OcKyKBjPRQuDzWG4Nh0ZBrLBOis+AhpU4E861CB0cBe0LqrOQf1qLwT4Q+RbyZp7kDmHan0dOgyXH02CzUdLLJsReX/BYfC0r4MMtmnoV/VrwwI/a7OA8O1nqRGc7Pgf9FH9/WkoCLci47V2S7wy9AJNOhZvb4Fr4Dn09Z5pD0G9a1MIQaT+8ClYS2fF6Lni5DhQvKnhgPqAPhh2Fudq50wH94EWwo6zkH4GbgD7Ac1jgCj1lfhOPhLOmpuuNDMlHomI5ez7xx4COwPKxmUhq2xO8svy31GSTrbvOFSfGzelZbWR9vVw57weDgEhr70vDYndKBur+ioHfylDyPtb8eUA1idu4pYCXreMnricJVFmb6MnGfRR73WySZ6Poi2qOcBsFTP6ugPUDt0jDcElOW74j+lsGnwBFhtTFinMrmiOob7nie9ijLC5MnHyjCCvYXL7nWkuSFNnq61aUzNgmXLv8LTabQOoiVAj1tQ8Rehy5s3YamuHJCvwbPg1a2SExl3oP6ToRNBLV05a2tM58Ar0hoUeXsM5Pw0hZwOV0kKU5fSAacug4PjsEfQMZZ9yIUMrkA+A5eDQVcGJA42J6t74J1wCnQ7xW/Q2cedoAxtcyno+DISHwg3h5vAUVCH2xNHax89Cr9O3VNJexXQj/J/CJ4EDUiCntWb/W3k6gTieGoKkGEPCjZy1rm/U6MS+98J9Tz4uzRjwhvuhRtBG1jqFPi4EGy0zAoNSFQre0GO9H+DHK9zy/XwQhobOid9KQ3KSSdtTVFfhcPgG12KNWJx9r0IOvPV6sQutzfuI3VPQFad0ylwDVhNFh1Jf+gM/z7uuzJHHV9IlbOgk5Y2qk6Vxz42KtTx6qC8vjpsGGintrUb/DjUMVqnMpg+ACfAG+Hj6KPqwOe6Nq+NSiPcxyl/EqnlKvtOcBvog516HK06WQseTbn/TX0LOXjOFx0fQMBPQCeh0vGrvm+DjuuqOiZPT3EdBdgfn4Urw2pjQhnd9vsYfAzeAavCCNYlzFDobFopMrDzXeJ8IckXnCYfK0LHMhv+HBoJVSqbS5nhILCxRiAaejWlZC487Q3ozjbuDtWLA12DL4VyOrjOgZchZxq9ld7flGPkXp+C/wuOgeqxGmyjRn4x/BVt6DqBVLu3adcS3Y+mgmOgg8NBkhXaT2cEm5T5Uc59HDqQ7C/78GF4NfwH7TeCaRiocxSFWedY6BjMasvKJy6E7lNqb4UH7d4LIb8O1XNpm7W3J+Hnacs00lyAPHtTkfL4IKzWOF2CPFPhl5FxBmlFLE4GZ71HK+ZILiDAAA4daKFDa91ivvlwInXoYNsROtcvQXXT1bnaXo3FgekSu1anmT8XIMuD9OfZVHYGXAVWc7IavwZ1JHyd+y7m/nJt5XJ+QAblehR5vknqoHBbIa1tkrUsHGTBuVqW7fwH1HHNIW04KHcabfg+Bd8InahHwiz6NUo2ePkwfAyOg4UG7XWb5FPQbZNS21PnjhNf8s/NuVKfuAaq+yPgklC9VoL948R4PG35AbJW9G92TFroLLJChdVzX9Z6cs+PYl3iuXekcy01kiCL7XY5eAEd4MRUKCDTvxDofPgirGUHGr1Gdyw8irYXpk8T3f4UuR6C9YDmvOdK7oPc/DloRKXdGkXp+BxATXGulN0B2wBv5oMR1I3Q+mVa2D86qyNohyvNwgL51kS4k+EQ2HXcaFc3QYOSXIH+1eFF8Fq4eIrKneB3hYdUy1trYFW7t89ew0g2pvFfhYNgVyNRLxrKbHgOHTfXEwXFn5Dr4pSyaYBLw+OgkXthgI6N3BwY9cCBsi900A+AOran4Lcp9y8wtyU3dU2m3m/B8TDNICdbJ7TD9eF+nWcKdsC4caVxIlwHqvdS6IvmQ7+p9mzphbyOqfcV6nI8PAFr+UYjXPvokGTS4LA7ahXS/Y4+fgZlDkQFLuVGwDcrqMNBeiV8oML1QpzGoByUOtlJ0G2AWtDJutf5CfSwWa3MOV+/mfpcumVBPzIbufqK0HLQifE+eDq6+Rdp7qDeF6j0Z/AeqDxpEZa0e9I3RoeFAjI5Jg6E28Fy/aQvegiq/1ZiOpX/PaUAThJOyh+mfdpSN0QH200llU+gRJePLiONYHU25eCspmMt1L5rOUE9x4B+kcQBPQOmGdA65VHw6+jDtCi4H0FeziiMEfmx0JWIg+VWeCo6mUjaMlD/41T+XajDyRLJ2obRcH9YNOyMQB+DbjWFySDIqPPVrnxT5dVwshUp9SvbVfARmGY86Af2gmNhN0QH200lVU/swdXdoIZcDhqKs7NfNZ1XLkNBzzkhXA0rTRpdxXYwOJAPxcmmiXy73t+Mzy7vsi4t7S/lN9Wpnkm/zSZtOZBjKkJcCl0lKV8a6Bx0CjvRLyumuSGPPMji1sDh0Giv3NjRDz0NtcMiwC0iH3ql0btjxv3vvWhnP9KFEB3sQuqo/AHlbcnVT0Jn4EqOSON+GF4Lew2SWfsKBL4LLp5ScJ2s+30fSJm/2dl0RFknNQeQfXk59GunM0iLhH8ijMwyTm3PCLgZLAoOQhDl0WYqQedalMnNSeAWqKNNE8Xarq0TkvwHWTruP3f1sSOc61I0+aNwDVhuBg4a0bjHwWfCid6S4lx81eTP0Ag8zcxttOSMfRj6GUXaamjkWZeX3uPE8tOk/a1uw0L1I5OThvL9G6Ydq/aLWx+b0C9p7yF7c4AMa1Py/rCSTSmjq4/baG+lwIXLuWMWNco0OlTnPpvYvavO09zMfX0eu6KBbaDOpxKc6eZAf3FHhfdGOGs/CNPahQ7KAXQ4hpVmpidr0+DgrNY/5Sp+g5N+5fGlchcLcs695RthJQdVTkz7xYixf7mLeZ1LbOJQ6nMCVqZysF3PQVdPhQE2oS1NgWnHsoHX5nAD2Im0A6nzhr52gJGMps1HQ6PYaspWl3fCQixzkCMzMKqXuel3cD5MO6DVyZ5wQ9hK6GB1mFlRbUWStayG508GulGsK4y041VdvB+uD1sJX8fauYYAtklHVsRV33Tk0j7SjAXz+YbR/vgMtxE7kLbDQv6+mO5Co3WylWZgdWIHuJx7iAFRzQmbt+i4GwGNmhZPKaiDeXm4D4blJNQqKEe1PqokV5rBU+nevM7PpCL39tP2iTbo9o1vu7QSu1G5UbR9UwmufKYmE0mlPK06b2SdZTyb173YIUHg6GCDJsqkOIxBnN4bqqdqinaQGmHcA3s1MHSNyq+H6qzSOh9nbwfTTrA3Qbmr9Wsh2kKfvI4gt0Mn8TR9YpuMojYsjab4nBuodzCVGZzUklc7M1IsIlzJZbEP7cmVw46hMdHBBk2UT7fl9HCo4mphBhmKuMypJXe560axtqXW4Aj3GqGsBHdhYPUmm3KfLcsACu1tReoL+O4Vp+0TZVwFrupBnsAGlHELqLOpNna0FdtU1HFj9J1F32TvyL8VOuhYzfWmwaDwuQEF+VRwF+gSJs0g1CllfYrNLYWE7yTeCbMYlwPJByvDYETjNfAERc7OUGyY9Hz3NG842e4D9S/Vxo725Rddsr6/zC3NA2N/cej+8eEw7fgPAjkO1oRjPJF2T8e8fQ0b0mCVVG0GDjrRmB9hKVfPHmAoozAp7XgHA/NbTXvBWoMkyO1AMlraGc4IJ2PaMA04eTuJr5eyRPvDCMwoNm84bmQ156pMOtjXoA6tFXIGGZTDLRUno+HQlav7135OM/7J1gl9gePAtwnuiw62Uy/dDnblzApQhVWDDugF6LuK7YSpNMaIaThMY2QOJmf7jRgs/ZJ9Qz5GNEID6PMt9PoQZdVyWqE68zm+c98ioM4t4bKw1tgxIBkCz0mRlyxNgTarnvxGX0h9j1inm8buyVYW69BfS1tgRBcNoBi/ULApVD+1olIdrA+GfMjVTphJYx6BIzI0Sl0ZYQ2GUzPcF7Om08Bsss2H/jBNWkerLecGxo6yufpzXKRxUEaOOtlWI+jTtNbEUEtWy3CbYBmVENFdA3b4IJjGQJzpXoYaftvAiInG+GqQqW1MAw3LqH8MAy3tPWnKjXkWaEA7c7WUdtzaHwPoC6O0vGDE7ASbZuwokzKat9XUqUrl6Sksox9cNG1H9bTC3na/UZhLnDTKVodt52CTDptE6t5fWmepvhzMO0KXXBGN1YCTuA+FsoxbHV6eDnYk9Vln2ihQ27I9RaIypSHZOhHy2w717X75y3GLoFM/Cw6Y7VVQmg36cKeKfZWIL61Bhft6Q/okQrr9YVSaFupvFHSpOC/tTTFfKg34PmyWCc9C7Qf7pOlIImXHjmMiLXzIlTbaTVtmT/Ipu/rqmgYdej60L+QzsHD8+01CJ0EDk9/4HCI6WDTRBb6eNRKmiV691Xz1fEXTe4sOjd+9VB1m2kGgPlaEQ2B0sCihgcjqYO0LHWxeEayrlrVgcEAcVoR5bM9v4GSYl4xUVRU6TfeFbUtXeqM+Mzhbr3vs2LAtPuh2vMzEub5J2pHZNOI/GnD/yNdbsjjYDmX+p4j2OMJIfHI9ndYEg0rTMPXm9ooO1pfjIxqkAfqD7njPyTyNAwu1uhco83hG4ErHfk8D2+D+/h2068E0N/TGPFkGTm9sXz0y++0TDTKLg9VQ2hVP07Cs2x++5jKgXRXS4nYZLWWBjsyILA8MpBL7PsvYydqePNrRsDqig+2uSh1sFiOxhHY2Epc9PsRLGzU5uFzuuU0Q0XgNOJmndWDW7hjPa/md1cFqU3nJpi5yR3Sw3VW+Cqec8bMYcfdS2ueM7/e6vEzrYEPL84qaQn0xLa8B+y2vZy1+RTbLL6opW1vbSXSw3Y3S6DWrXvIy4O7SNv+MrwVlfXLt5OQDgIjWasB+yDNKdA/Wfk8bnCib461tkdWRtK0iShqWdcmiDt2zbVe4PeATUgdDFmTVY5ayY970GrDf8goAfLiZpS7HzvLpm9L7ckYH273P6tFJOztYX9WSWREdbFaNNSe/Djbr5FivJOG1pTQRrHm0kbbeq6/HmdSr/MLfxyswwRDTGEhpe/qV3Ft6vh2OfYPAfdisbxK0Q9tjG7JpwP3ULD5FB7tatip6V+4syuhdLatf2uBk05agM3YfqZ03633IlXXSSau/mK/vasDthOhg+0r/+yI3bZVZnKz5/baM+0/tCNsXHGwWvbzdjsqIbaqqAb9wk3alo10ZwQ5i9Zdl37aqAEW7GCPY7j1ix2eBBqWD9Su27Qq/PZRVL+38bnC79nNP2+WkmtbBWpc25R6sr3e1JaKD7d6tWQzEu4OR+PXadkXWl9vVQzt/u61d+7mn7fJ1Pp1s2pWOY21luDpsS0QH271bszoTjcRXTfyJtnZF1uW+A6xdfwCnXfu4Ee3yHxhmmViDgx3ciMqLWEZ0sN17RSPJ6lDU41D2ktpVn1m/NOD2gPu2EX1LA34pxX3YtBGs2jHv6HZ9C6ddHYIdVy/87r3RV1bdrM897fo+bJY3JBwwfjFhLozoWxp4huZm/VKKUezGsC2fYWR1In3BXHSw9fz84Kh2NRLapYNNG5WYzy8mqMeIvqWB4GCztFoH6xbB8Cw39Za80cF276mZnMr63XtL8X2+4R60GXSYvoKmraR5k8D8fr12FozoWxrwv188C7WBtAj7sHukvaE35YsOtntvubTVULIYiY7HJc5asN2gHnzSm9ZW1MVs6Le/IvqWBlz5TYdpJuKgGfO6x78p+7Bt9yZO2kETlNEXUp+CzoBZdKORuIxeqw0fdPkSuG9JpJ1wfMB1H8zyNJnsEW2gAR8OT6mjHUaxI+Daddxb6FuyOJFCN6RRwvFtLju7nn9hoWPZAA5olCwFKccvUaT9STntyQeEE9Fj/KJBQTowLzGSb0I+Qn31POhyEt+z3d4miA62vPVN43SWX/G3FB3KEDjaD20Ev2nj9ocTTy1oT08mrJU3Xm9PDfhw8yno12CzQPvaGrbVO7HRwZY3AR2s2wRZjcRtAmdh03aBD+/8IWW3QWpBezL690FHRN/UgH3vNkHaLaWgJQOUQXCfdho/0cGG7i1JWer4gGYytNOzGIpOaCPYTrOw31Bz+VbLwaonX8+alCwVOYzoaxqg741EH4I+8MoydoKq9ubAVx7bAtHBVu7Gf3BJR5vFSDQuZ+GdYLtgJA1JE8lrS24PTGyXhsd21K0BbeA5mGXsWJkBzVB4aLvsxUYHa7eWh7OwzPJTakZ55t8ZA+n1v9ROG/wHdmOghl8NYSDdkkT/1fLGa+2vgVk0cQIMdpGlxY6hXeGWWW4qat7oYCv0DI7Cp+G3wKzbBOb3dZNNYG+H77+OgEbm1WCEa/R6U7VM8Vrf0EAydm6ktW4ZZXWy2ppbUkcywff6H1DK6mBrDTT00glnIsvPquDOAgpwMB4ZpsI0S+RScX2t6QAMxFecejO2QHgjcfuyFv5OhrtrZYrX+4wG7qGlWVeAQTm+Q70NPJYxlGUFGe4vTJrFwepcs748bvlZ6iiMYhSEmdgnokaxIstE4QvX/oCFRtIrkRj2ZgjvNkE1B2v/qqd/oq9q+chSOPgNoiz9WrgGpBQo937BFl5Ftpth1hVgaJL94gOvXjuGbEgW56eDzfoCsbNPr56BkP8v8H6YJYpVV77adAyOanXS3ohRCF1rm8NBYFuvZEA91gsbqW06gbQz6gmMGqUPHxTXswK0fuV2i+rzjKF1PNEbkcXBOhP58n1aOGtqvEYJvRY4jpkI/wdoVJol2tFANAxn4d4Io9fB0H6vBCedh+HllTL0gvPt+hOTql57dRxqu7mDsePKZhz0eUaWsRNkdcU8Gn4JJ6st9gog6xj4QTgqi4O1sVleW7Jj/QZQO0QI42nH7TBLNG77xUEoeu0Fh73jL/K6d7wHrDYotB0n3IsYSHNIeyNsXzt9KaRcHzjRt8TBJsJcSXonrDfQUvbN4UnY5UqkhQXy9YfHIuDZ8FR4ShYH64vDc2G1QcflhaCD9YlgrwYOxP2k30AdSZatAqO/IfA4lU/aW7AVgq4LHZzloA1oO1dBJ58iIMiURRbvqXfgZ6mnVXmd5G1jlsCgobIydnwf9mLoZJzF35TK4TjaHX6RcVTINwuQaxjyfQN+Fq4BbeuyqRuMonSws6AdlgZ2ruUPTJO5F+RxH/YS6HIntd7Iq3HsAA+GhQeG4lsD+0CXzvZhOdh+nxBfil1UcsLl7mvmOWWqZ7VUzz3NbEejyzYgWLrRhWYszzcKrknuSes/SqvQDo1k94KnYKMDSi+28hhZFoVuA54Bd4GOBzkfXpvFUZC/43c+szzosnx/wq8epVpfYYAj0VH+CV4Ns+hN43AQH4UetiMtOg5CQOV0S6gcjIamwh+gk9nlMrTonI4k636qdpllRdKipvWoWvurpQ4WO9GWfgUnwXr1HQK2PSnjdMaSb+m0FMiwDgJ8DX4Trgd1rMppG2+Bf8riKMjf8Ss5blynvU8DXhu2xT4XhmL0egGcDLMsLVW8keHxdMoY0kIC2UYimJG2bdNQukLDcWY+D10Y0RcJyuzecVZkdcpZy291fsdqy9uIvbi99hs4D/bEyeqst4bfxl53I80d1NsPfoiKvwdN9W9G2MLj6fAi2jw/raP0RvEknAXT3qdjGQndz2sLJIby3zTmXmh0kBYaxobwa3TO4LQ35ZUPmdwrPx6+H9pvXWGfvwj/F97Q9WIBPhulZX0lzoE+tACyN0sEJ0kHfCEeDjF2JiKLkWy9PwTDrR0Tv/Y5BJ6G3bplsA5s+irZMQI/SL0+xPoKHAaVJQQj2tPj8Ie0dQppakdpXl+810m4n6K3TtMgl9Xul4xFsLROmezFBnp4EAl/BJ+CWZysenNp4xNRHVohkPSNM/HOUBm7wr4zer8QXkb7NaqiYRACZX0AYtS7Fe3P0oetbreDOM3YU04HvtGrjqAouAJBfLNApG3HgtwL/9W3+BD9MHgW/BD9uBppw0G5y8HdKfgMeCrcFmozyhCgLT0Bz2R83BZO1uP0buXmF2Ba5djJ+8IdYdOAApaF/hbrqXCDplWUFIwSXSK7RJgFVW5a6MDGwm8h5+C0NzU5n/uuR0ONJszGHHbAAf0aPA/+lnaXc8AdGVv8ZxfqX6oOGXbgnpF13Jf7LdjLolTqP6Ds2kfVZDHvFtzryqTlwH58hnMu9FmG9pbWj5C1G5zotcc14MnwZ7TzBLg27NG2iPdDnx8dR7k/gafD7aDjwUAz9IHyO/4fhafTvltIO2EDs8LQVye7P0wTyZhnFWgoryA3IESp5+dU/aBMo5bt4X7QjeYV4OOcf5B6ghI41XhQ/s3U8xwlu1wwMrWza9XpdTtldziQ+79POQ9xnDuo2/73jYGToAO3a7/YX0/Ac6BfhU3T32TNF7RD52EErgPKiiHc8BnK+ALt69r+rGU1O39/KjBKy9IPOoONoP38S9hyoOfn0bfLbJ2g48DxUGvckKUi1Ie2vBZcE34ETqOOe03hY/Ap6p1PWhbkdYtJWxgO9SM+wBoNV4Q6Vcd2V70He/sb186n/BmkC8GGZQbCbMdN34Hu7aQ1SoWcC38P/1itsVyvCWRwib05PBi6t+nnoIAvUf54PucCZLF+nawdo6EEOTisCo1C5/pL5L2pas4GX0RmjeNQeDQcAEv7Ubuwv2bDnyDbdaSFBW35HMJ9HzpI6sHz3HQS7by4npvzuod2al9Odg76tDamePblk/CLtNEAqRCgPUMR5PNwV6j99cTJcnsntG1t2NTnBrbdPvYB/QtQR/sm9LoPRvVjBoGOg4HJZ2WpNpYdu0bj4+A56NVAqxvqdbDep2KOgc6QaWFHK/R98Hp4A5yLcKWDm1PlQYe4BBwGt4W7wbWhm/ihc2z0eHgqZarE3IBsK1PZcVCHH2RKU78yK+uf4B+Qe06am3qSB1kHcf/HoFsD1l+qf/vIwatT9W2B6aSFBW2xDedD9d8T2Ae/gO6h/bsnBTXjXtrpyuwbUGdk/2TFEtzwMPwlvJE2Og5bDtq1LELoSw6A2mI9beO2itCJBprJ8kvbHhxxuOb1ajKY3zEyHf4c3oQuK/pAM9cFFDOEG38EDcsNn7NARb4BFXIytOMfhxq5522gSjGfUYmzylC4PhwOdRDBiaks89qWf8GzabD7IbkDnbjproP9MFTecssKTneD8ptXPVwKJ9CGV0kbCuRzkG0Pj4QbwOBMOezQn/p2Jv4rvAAZnPULCdqiwzkWngSHNUhIJ5proX3gVpaRT8tBW41Y7bMjoH1U6iD4mBr29zPQyfwGOIs2vknaUtC+/gjgmLGN9qtjoWgIjlX/NAmmelWxbgdr61HM5iSnQJ1sRS/OtXIIAmssOlSNW6fyWnKs01kK6rR0DH6WwrzeF8rQMV8N3QcpG6pzLTegl3WozMG/HXSCsH21BkVoizq4C94IJ8B5tKlHBpcY8JaUtTvcBi4Pgw457Bi0Lnc0nAvhPdTp9cKBtqyKUDvCT8A9YLAJDhsG++p+ODFJHyCdDV+C2vlb6Ec7bQpoo3ZvRD4abgI3hhtA21rLjshSFUFfc8k1GT4G50Dbp/O1jW80s32U3w20WfvfFZ4ARyYZHDdFgBOT4+FxeAm8Hv28TFoTNqpHQDFbUMC3oVGljqBeA1CWII9pKMc0HHPYAa9rKKZ3w8vgtTS6KB3i5OMg0REYdWwIlbXUqfGxLMy3OFSXs6BO73Y4Hc6hjakiDupfjfzD4aZQp6rTV6bQR9ajDuWD8M/w75Svgy8caM8IhNobHgfVpzrKCzpTJ6CnodsHUp2NQ193kDYMtHNNCjsGGrw4ES4DRdYAZsFdlf/a7+rQMWPZ2pW2MQ8+Dm3X32ifDjc30P5hVHYoPBAanAR75TB36FjVk/19ObwKfTgZpYaDrMdAKTtRSDB8nWGzoh/l1Sgsfyq8AWZuNPfkBnQzmMr2hLvAtWCpk+s6cXC5E7Y1UKf3BHSA28F2+AvQ8w4QYbkuJY183g8HwiHJZ5LOSSro0KWO0csEqGOdSVpIoEMnh/OgE0WejrWWPh4hw4fRnRFuj0E7HdDfggfAUsfS1U7sw0YglBvK65qeRtuubERFWcpADzrW3eB+cCMYHG2wdU41Deog2Jjj7Xb4N3g3usjs10JB3F8/qPgmlOKMfiT8AFw1Ka1RCtHwhA5lCrwOGrG6pCk0kHE2Av4a/fyRdCzUSRj1u++k/jXyQA47UXquH2fHwPWg5+1oWZpHw1BPzrim6j7k8Zrn/WyE4kPGCfAm5NNRFx37I+AONYRUF6JUJ+FcON+Rocaf4GTM5nHQXbnb7BOdf0McLOXYR8tC4XFpWzpOJn9Cu8ql4Vxpfo9Du0KbQmo94Vq418/a3Cowd2CTrhiuZszcQLoz3BuuD43olU3bDrJy2GNYZtC3kfzDUMf6T2QxCKkbFtwwoJAlKGwDeBDUkdhBDnYHdqlSKiknyBMaHBzFXO63oVfDu2h04R0rcpYFOnI2dhm4E9wMDoMrQZ1tJT2V01fQFbd1oPRzqf40mBfh49DthpvhDHT4CmmvADo7EEF/AnU+LtWlk62TxbPweeig9Fy4zmHHA9Og0zc8kQI6FvWn7Xm8HFwdDoWuRpTB1YLXneyPQpdTSRsC2roVBR0GB0DbY9+9BQO0BftU2iavmfo5HJfm53SHbTk2l4TKbRvkCnC15NjrXtPRCHV6Fm0zcGop0IkrM/2KE+260P6wD0LfqpMwRkLKqW4IY8S0dIyov2fgw3ACvI1263N6jFBhjwsqLQCF2Ekuh1WGe4DrQJeudrCORJondCaHHcpSYcFQbKANlnfDmTTaZVPbAD05gEfD4XAMHAYdyBq+OgpGHwy/a39pTMHI1I10cDkoZ8HpcAqcCaeiP3Xb64CebPcoqF7mQ9tn5O3DmGoDiiyNQSKD9Rs0GElpuz6Ff4604UjG0HvNbl/SLu1LWwwO2GDo5aLZS6KTNZBNZ7s2dMwMh8tAx0qpbykdK2GcOFYcH/IlOBvqXxwjj8InaLNtbxhKhWhYoaUFoRQbrkEOhjrd1aBKcga1U+1cG+6gmQd1CtPgTGgnt5VTpU1lkRi60a3G4gytvgbBlRIaSamvAA3BmfdlqLE4A8+BGo2T02vozqguImqgLTXAmNGHGN0OgSPhQOgE6EToZBHgOHCcOEaegvoWOZ8x4oQdETUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDUQNRA1EDWQlwZS/x5s8nul/qCt9/hfNTP90DH3+7uvHb/9yr3+/muuSOov/YHvWvXbTn9z9Z2sba1VcLnrdchXWoyy2h9vN1NWZFR/2kDqurhH2bxHqMuaP2jc5Z53W2EvC8Rd8Bd5lN/f6fVX9ENbbIe/Vezv7r5KWhgk8qr3SmiqnVSqtOt55MzsE5K2aYe2Tz9U05661tvTz8hg3f7Gtb/PHHyKPu115PF3ZzsRjKXzRJWD0Vw7AvrDz5Oo5LKMhv9R7vMfmI2Hf4V5Y0cq3B36A+DVjC/IZR5/nPd86I+BNxuHUMEWsNzE5TmpTOVk95y/rH8u9F99NAsjKPg4aH0Xw8mwFjYjg21zMI2D18Fa8D9gaC/a50XQX53PHYkD8NfzD4I7wffDMKDsDx3s3eS7ltT/MKu9tBTI4kRwPFTWYDNBpiDzU+Sz7x5F5lnhYgvS/ahzLPR/+v0FWZSvIsizPRf3hrZxKtQGF3JofG4qkGEYFSi3Nj0YOhaEjn461y8ntS3+6H16cOPu8CUoXoQHp72bvIvAK6H4cdr7GpmPer8G31aADHiAvBpq00E9F2aQq1zWGZy085sGyh8NH4bimzAYV9k6vQ7PhgGXcVD6Xxkq3XdKcsMc0rXLZmrySerdGP4ffB6KN6Hy2P77oYPpORjwEAefhf7CfstA/StD7TYNppHpW1BHkTuo9+dQmDoBlwXXtKMD4ZNQ6JC3KZu5iSepc1doP4t3ofbg58nwGRhwOwfbw0WzRLBh9rMJ/kuGUyngdjz1kynbFLYFcg/pE/msV4fwCDwHVp0tuW6k4j/U838/5QFn4zthV/2ot53hoVDZfwG7/m8t2+W/jXkONhOzKHwiNMLcBZ4Fqy2PV+e6EWzAphz474JmhBNdU2xKm9wqOX8X6cyueZr9GRl2ow5tZAx8HV4A/wlvh2GFoJxDoKuiA+C28CdwO+7/LOPCf0/SKmhD2vdv4W0lQrh6Wx6OhjvBkfA0uB4yfxyZtaE8EWw9pN3qRq5FOXk0/A70XyjZDyci6zTS3IAc9u/PoDZh3dr+NdB/c+X4c5I6Cp4At4auehzP6UAFu0Fn8/lwLhQ/gzrbqiCPM9AVUChY7qDeEBWNy73yHlaI7MerOHAtdJC0DNR/AnT2fhZWjS657iyuzbwAX4ZGgftVE57rq8EZUJxWLW8zrlHnPnCKlQMjwcNhv2p1cX0w/DF8DYpfQSeX3EG9RrBG2G/Bj5UTgPNLQCP0i6GwXw4rl7eZ56hT/yFMu0WwnFscfhrOg8IVxYhmylSubOpcLKmbpMM2DC66gWtLQlcxP4VOvp37Sd0yVzjhrP0YPAMauZwIj4W9CTp7Z8XehGB8zpQtdbDUfxM0ilsZ1lqmaYgumf8O/wKVfXdYDUa5RiqvwfHVMjb6WjIoDADWhHfAjxAp/Q4axVYE12dz8UvwVDgfHpcck7QUwW4WEgJ5fTh0LydPhu5v2y970n7TQgBZlkKQU+DZ0H/86YriBOSeQZo3tMdg6xcgww3lBOD8m/Ac+Dn4hHmyOhoHuOH8b+Gfk/tPRBkuGSP6hgZm0swpUFswCjLthmSA7JxccGn9j+R4M66t2u2G/5zYnEP/I+gs+OB/Tjf3KGnH0dRiVK6T/C6DROeTCuR9j4znwYuTGw6hzNLtkVTl5Jzp39QXlrE6EZ1ay4He7P9vwa9C9fpD+B10bL+0Av2pVAoDzNTI6mAt2Hvcd/gm1ADXgt+uMWjIEtEOGsDIX6Ud1ydt2Zp0QIV26ag2ga/A8fBG6JPV9eB2sBuwIaPdECmM4/j5bpmad2JdinYPzQlDJ/lXmAmJA/geN02HA+ExtKlsFJmp4CZlTiaFN5pUfF3Foi+X1mfDr8E34UnwFGR9hrQIcOWWGvU4WAtfkgZrRBrTS/CD8FMwom9owIdPDkydUsdeU5lmu9R31n8EzoQOkHug54xSy8Gy1odvwwnY2LvlMjXpnJPFKPgcdFvAyCkzuM+l4bXJjTuSrpK5kJxuwJktS1UbJNU9TdoyZ4ve3kEendfZUF+ivXyd8+fW2xfc3yg8T0EGlWJ/5Fx1wWHtv/U62FDy7zn4OXTv5gtUvFu4UODUF9fzHLgFVkXdorl/9yBcHm7btRTswL36bZLzN5O+gs7fIr0lOeeT9nIPjox4dbIPwPuSvE1PkEX73QEavd4KU28NkLccbuTki1CHPQa2Cu9Uqpg26yS+ALeAjofrkj7iMHfoXEdQ66/hh+B0eCQ8HxYBTj6uwsSe0IdtW0HtvCpqZqh2Nx3yNpX8lDy7QaOSb/D5Yc7PqXZfC69pcEOR8RhSjcoBVQ6eN4q6mbbMLJehj597nPZPgu4x7oQ+jTLUV4BRm47XiOhfXAvR4J18dh/N6HYQdCB1gDJcSmtH6t4IufMax82Ge37BEU5G3hCt1FuvUftsaIS/HnSSyRPq2+BpDHrdnjTYuePdqFXHvx/cBXrN7ZgrYaug7/gNHAvt+5Ppg+DQ+NhaIIsTgJH1aLgr3AtuDH2v+3pSJ+V5JXbOxwVQ4T0ChfqtkDMp5JfQzvwKn7/C+Td7VHBzbtYJaPR2Zi0o/+EwOtgumtKQEsP6BJd0IA7YR0uybcDxmlDd3VNy3qjUc/bBVrDUia7EZ6NencNE6niXNC84DpwURE+dayjjRQ50XpX2qM3XLAQH+xkqsI+E5+QS0L1u8Qq8Ap6JvpW3VdBWlk4qf5I004OkPIRGP49i88dT1+lQB7s6/Bw8Fmr7t3L9clJtt9P39djBUqD4MxwEfwwV4kH4K1g0GCXNhj7RdgA7AMrB8yqp1AGUy9eXz02g8U9AnasTa4eDxciMnFzmLQX/BUt1+G8+3wJ1sH4zsPTr1ptwbih0v+tmmDeCLWgXPYVl6MxEKHfBp3z/qu9noLIYpbu/bXorvBjeB+/CIRh4tBI6pvHQ1fD+0PdJj0Eul+aFAfJMQ66jEcigYg+onWvLmyU8jnQ8ec4g7+0cd/5whcd1g8LcKriIAg6AY+Hn+ex3s3VmRYITio7gizDNQHqjSMIXTJbnkOduOAxuVCJbf463ST6PxwbclukAx5jFew7uT8INoc55ChRGvQ7+yXAOzBPawktJhSs0oGLLWCYppxWRoZOcev8Z/F0ih7r9H3ggXAxeQX88S1oE6OD/BAfD70MjxNOxFR9yaWeFAfIo633Idj/pJXBTeAjcHmrP+8LVuX4keR+xIxoCCnuBgr4GH4fOlN+lkpVJiwZ/SciHLq+mYKdzKFojWi0PuvOh1c2JHD60Co4pOE6jpxuT66XJJD5MhTrU7bzAvS4Pt/UYXE/Z7tPmCSfS4OjXRp7le1j5Wtw/FL4OH+phWfXebtT6PLqcm/AJPn8PToNuzxgEGXAUAUb5yvsT+E3oKuaT8FxkHEhaOKDT9+BT8G/waATcFf4UakvuKev/VmiYg6XA91HRRBJnICs5DJ4IiwbDqIa2u2gNzFGeu6jLidVlkg5FbAKXg3fDObArZnDiNrgk3DK5uBrpFtA9wTuTc7kl2K3bQdqu2BoaifQE23Cze7ruJxqRtwpd7dzJ7WyoQ9OB7QiLgkXph3cR5iz4bWhwY2R4BuO1pxMexTQXyD6TGk6FRrVCO1q9awd0XOnhn99y/2XQAfQZlLM5lTs7RbSfBh6gSUZE/aCvrSxGugMUk+h3J9qFwLnXOOHerNiSe4xedcouDy3rPtgKuHWhQxwCD65XANqzKvfuk9w/gdRIvhBIxuEfEEb9O6n5aqX6LwyQ0SX4ufDH0BXAUfDMRK8cFhfIboBwKZwH9X/LNdzBJpWcRuHT4erQGWgAqYqLaCMN0NdGrzoRYTQ0FG4PX4W3wErw2ny4JtS57gu1RX+d7QnSVsCI+ypodOeP67i3Vg8+wU3rQ9t3Ke0xOi4MkOdZhDFKdKL7ADRKLBSQ0YnZaPAMqF2cAM+iT5YlLTqcUHW02tEiDXewth4F6Vx/BK1oLFRBS8GI9tOAzvJduA48GK4IdZL3w0owUtVGloP7QZ2sq5zrYEuAzb5Dxb+CT8NV4akMaAOE1CC/7T8xueEfpGHySV1GThmvpZ5roOPfX3/yqXihQH+4x/8/8PxEsMNJ7ZNlks+5JtTbD45MUekw8jgGHBMGGulA4f5c4SvwXuiSsCrI40+N+RsF/rSdP1Xnz9sJZ8/cQb2ndNT+3nsafq8Ccn8qkf2fpC0xsEoKQ54R8G74KpwN7W9/um+xSvd4nutGJOJp6E9gTodrVLsnj2vIcAz03W5xLRwLqwYiXO8PT4LhR5f/xrHRee6g3tKfKzy2kgDk2wI+BsUFcIlKeZt1njqr/lyh9ZJnefgT+Ab0hX9/ClIHlhuozy8n/RZOhrtWqphra8LxUPwV9l+8UuaenmcG8tUt91KMUDaGRiuthrPKKsg1ljTNvrBh/v20xT2ViPIaeJLT7ukZhb4fury7NokIOawI73GPbWCS4x7SZ5PjViYXU7nj4ky4OzS6c8IYT/oQ7bJ9HeCcD7K2gh+BR0LtZRL8IvkeIy0skO9O5L8EAU+DB8AL4U2wUEBOg7NvIJT+47iEczjnr2sZ5eaBdanErRQnof+lblfnV1H/XFInAfdbN4LfhGOhK3e/3fgiaTpQiC+GO4s8CGtGsKFU8u4LQ/TKYcdXzsLl3FLq9V/GOAMKo6203DM3IStUhKyfUWgwHhYqglVkZDoSBviNFx1tVZBnFLwt3ER6ctUbcr6IPHvBG6A2L4xO74BGp1fB8dCx4I9VCyPxH8LhOYu6UHXUbwT7MBQfX+hilw9cXwPeb0bwD+iEkRuo71wrBqa1VjwGRpeaGRi8/QLmEslSzxLwBDgFBhjNXgO1hYnwOShmwY/DjvY4U6fFc2R078aIxUgwLcaR0ffv9k5ueCTtjQ3ON53y3HdytjHSSAPz+U5eqzETAW6Gd0D3CouGWxHoL3AlqJwdMztpNczg4h+gD4FegDfAwoDoYxyD5E4EMrr7ENwYbgZd+QT7sS8ehbfDS7jHtrcaRnW3wFlwdjVhkNetkB+Qx+jbh9BG63m24SHqmwAfhlVXlMiqA/sK+VxNGlGOhK4eHNNNBXWrUx36RNJPw53gKLgWDHL/m2P38H9NfvN1IBhK+FwxpXDD4xWgRvUihYSCK94TLnCvTm15aH2vce/8cC2vFBmWpi6jP2VIK7t5X0JenUDLgOyuGNSfy9OXs+g+D6GRTz2tCJ2w7V+XSDWR9IlLPwe3ei7i5GGE7sQxAGr/jgNhkKFduK3xNLLntVyluspI+qI/OYyg/EKNNlMR5Lc99oH53yD/yxUzN/gCdS9LkY5Jv/STyidwj+PY+7Q5/zODk3NuoH59mSs0bSI8uLfvX4IzkWchff8/2RsrkHyLw1IAAAAASUVORK5CYII="></image>

                                                        </a>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <!--<a class="about-link" href="/aboutus" >About Us</a>-->
                                    <div class="mobile-loginLogoutholder">
                                        <a v-if="!isUserLoggedIn && !getCorporateGiftingCode"  href="javascript:" class="btn btn-link" @click="openModal('login')">
                                            <!--<i class="fa fa-sign-in"></i>-->Sign In
                                        </a>
                                        <a v-if="!isUserLoggedIn && !isNativeApp"  href="javascript:" class="btn btn-link" @click="getCorporateClient ? redeemGiftcodeMobile() : $router.push('/signup')">
                                            <span v-if="getCorporateGiftingCode && getCorporateClient">Redeem</span>
                                            <span v-else>
                                                Join
                                                <!--<i class="fa fa-user-plus"></i>-->
                                            </span>
                                        </a>
                                        <!--<router-link to="/login">Login</router-link>-->
                                    </div>
                                    <!--///////////////////////////////////-->
                                    <a v-if="!isNativeAppNavigation && (currentRoute.name !== 'B2b')" class="collapsed nav-icon navbar-toggle search-icon" @click="searchClick()"
                                       data-toggle="collapse" aria-expanded="false" aria-controls="nav-search"></a>
                                    <!--<div class="collapse slide-down" id="nav-search">-->
                                    <!--<form role="search">-->
                                    <!--<input type="text" class="form-control" placeholder="Search">-->
                                    <!--</form>-->
                                    <!--</div>-->
                                </div>
                                <div  id="header-navbar" class="navbar-collapse collapse" style="overflow: hidden">
                                    <ul class="nav application-icons navbar-nav navbar-left margin-left">
                                        <li v-if="!isNativeAppNavigation">
                                            <router-link v-if="isUserLoggedIn && user.minVidReqdWork" :to="{ path: '/work'}" class="logged">
                                                <i class="nav-icon career-icon"></i>
                                                <p>WORK</p>
                                            </router-link>
                                            <router-link v-if="!isUserLoggedIn" :to="{ path: '/content/work'}" class="logged">
                                                <i class="nav-icon career-icon"></i>
                                                <p>WORK</p>
                                            </router-link>
                                            <!--@click="redirectToUnAuthenticatedPage('#work_scroll')"-->
                                            <!--<a v-if="!isUserLoggedIn"  href='#work_scroll' class="not-logged">-->
                                                <!--<i class="nav-icon career-icon"></i>-->
                                                <!--<p>WORK</p>-->
                                            <!--</a>-->
                                        </li>
                                        <li v-if="!isNativeAppNavigation">
                                            <router-link v-if="isUserLoggedIn && user.minVidReqdLife" :to="{ path: '/life'}" class="logged">
                                                <i class="nav-icon inspiration-icon"></i>
                                                <p>LIFE</p>
                                            </router-link>
                                            <router-link v-if="!isUserLoggedIn" :to="{ path: '/content/life'}" class="logged">
                                                <i class="nav-icon inspiration-icon"></i>
                                                <p>LIFE</p>
                                            </router-link>
                                            <!--<a v-if="!isUserLoggedIn" href='#life_scroll' class="not-logged">-->
                                                <!--<i class="nav-icon inspiration-icon"></i>-->
                                                <!--<p>LIFE</p>-->
                                            <!--</a>-->
                                            <!--<a v-bind:href="isUserLoggedIn ? '#/life' : '#life_scroll'">-->
                                            <!--<i class="nav-icon inspiration-icon"></i>-->
                                            <!--<p>LIFE</p>-->
                                            <!--</a>-->
                                        </li>
                                        <li v-if="!isNativeAppNavigation">
                                            <router-link v-if="isUserLoggedIn && user.minVidReqdMindBody" :to="{ path: '/mindbody'}" class="logged">
                                                <i class="nav-icon mind-body-icon"></i>
                                                <p>MIND BODY</p>
                                            </router-link>
                                            <router-link v-if="!isUserLoggedIn" :to="{ path: '/content/mindbody'}" class="logged">
                                                <i class="nav-icon mind-body-icon"></i>
                                                <p>MIND BODY</p>
                                            </router-link>
                                            <!--<a v-if="!isUserLoggedIn" href='#mind_body_scroll' class="not-logged">-->
                                                <!--<i class="nav-icon mind-body-icon"></i>-->
                                                <!--<p>MIND BODY</p>-->
                                            <!--</a>-->
                                            <!--<a v-bind:href="isUserLoggedIn ? '#/mindbody' : '#mind_body_scroll'">-->
                                            <!--<i class="nav-icon mind-body-icon"></i>-->
                                            <!--<p>MIND BODY</p>-->
                                            <!--</a>-->
                                        </li>
<!--                                        Hiding  Money Link 723-->
                                        <li v-if="!isNativeAppNavigation">
                                           <router-link v-if="isUserLoggedIn && user.minVidReqdMoney" :to="{ path: '/money'}" class="logged">
                                               <i class="nav-icon money-icon"></i>
                                               <p>MONEY</p>
                                           </router-link>
                                            <router-link v-if="!isUserLoggedIn" :to="{ path: '/content/money'}" class="logged">
                                                <i class="nav-icon money-icon"></i>
                                                <p>MONEY</p>
                                            </router-link>
                                        </li>
                                        <!--                                        Hiding  Money Link 723-->
                                        <li v-if="!isNativeAppNavigation">
                                            <router-link v-if="isUserLoggedIn" :to="{ path: '/events'}" class="logged">
                                                <!--<i class="nav-icon community-icon"></i>-->
                                                <i class="fa fa-calendar fa-2x" style="font-size: 22px;margin: 0 0 8px;color: #8a8a8a;"></i>
                                                <p>EVENTS</p>
                                            </router-link>
                                            <router-link v-if="!isUserLoggedIn" :to="{ path: '/newevents'}" class="logged">
                                                <!--<i class="nav-icon community-icon"></i>-->
                                                <i class="fa fa-calendar fa-2x" style="font-size: 22px;margin: 0 0 8px;color: #8a8a8a;"></i>
                                                <p>EVENTS</p>
                                            </router-link>
                                            <!--<a v-if="!isUserLoggedIn" href='#events_scroll' class="not-logged">-->
                                                <!--<i class="fa fa-calendar fa-2x" style="font-size: 22px;margin: 0 0 8px;color: #8a8a8a;"></i>-->
                                                <!--<p>EVENTS</p>-->
                                            <!--</a>-->
                                            <!--<a v-bind:href="isUserLoggedIn ? '#/community' : '#community_scroll'">-->
                                            <!--<i class="nav-icon community-icon"></i>-->
                                            <!--<p>COMMUNITY</p>-->
                                            <!--</a>-->
                                        </li>
                                        <li v-if="!isNativeAppNavigation">
                                            <a href="https://blog.tonenetworks.com/" target="_blank" class="logged">
                                                <i class="fa fa-rss fa-2x"></i>
                                                <p>BLOG</p>
                                            </a>
                                        </li>


                                        <li v-if="!isNativeAppNavigation">
                                            <router-link v-if="isUserLoggedIn" :to="{ path: '/profile/playlist'}" class="logged">
                                                <img src="../../assets/playlist-icon-b.png" class="playlistsimg" alt="TONE PLAYLISTS"/>
                                                <img src="../../assets/playlist-icon-w.png" class="playlistswhite" alt="TONE PLAYLISTS"/>
                                                <p>PLAYLISTS</p>
                                            </router-link>
<!--                                            <router-link v-if="isUserLoggedIn" :to="{ path: '/profile/playlist'}" class="logged">-->
<!--                                                <i class="nav-icon giving-icon"></i>-->
<!--                                                <p>GIVING</p>-->
<!--                                            </router-link>-->
                                            <!--<a v-if="!isUserLoggedIn" href='#giving_scroll' class="not-logged">-->
                                                <!--<i class="nav-icon giving-icon"></i>-->
                                                <!--<p>GIVING</p>-->
                                            <!--</a>-->
                                            <!--<a v-bind:href="isUserLoggedIn ? '#/giving' : '#giving_scroll'">-->
                                            <!--<i class="nav-icon giving-icon"></i>-->
                                            <!--<p>GIVING</p>-->
                                            <!--</a>-->
                                        </li>
                                        <li v-if="!isNativeAppNavigation">
                                            <router-link  :to="{ path: '/experts'}" class="logged">
                                                <i class="fa fa-user-o fa-2x" style="font-size: 22px;margin: 0 0 8px;color: #8a8a8a;"></i>
                                                <p>EXPERTS</p>
                                            </router-link>
                                            <!--<a v-if="!isUserLoggedIn" href='#giving_scroll' class="not-logged">-->
                                            <!--<i class="nav-icon giving-icon"></i>-->
                                            <!--<p>GIVING</p>-->
                                            <!--</a>-->
                                            <!--<a v-bind:href="isUserLoggedIn ? '#/giving' : '#giving_scroll'">-->
                                            <!--<i class="nav-icon giving-icon"></i>-->
                                            <!--<p>GIVING</p>-->
                                            <!--</a>-->
                                        </li>
                                        <li v-if="!isNativeAppNavigation">
                                            <router-link  :to="{ path: '/resources'}" class="logged">
                                                <i class="fa fa-newspaper-o fa-2x"></i>
                                                <p>IN THE NEWS</p>
                                            </router-link>
                                        </li>
                                        <li v-if="!isNativeAppNavigation">
                                            <!--{{user.corporation}}-->
                                            <!--<span v-if="!user || (user && !user.corporation)">Business</span><v-else>no business</v-else>-->
                                            <!--<span v-if="user && (user.corporation && user.corporation.enableCorporatePage === '1')">Company</span><span v-else>no company</span>-->
                                            <router-link v-if="!user || (user && !user.corporation) || (user && user.corporation && user.corporation.enableCorporatePage === 0)" :to="{ path: '/b2b'}" class="logged">
                                                <img src="../../assets/business_icon_black.png" class="businessimg" alt="TONE B2B"/>
                                                <img src="../../assets/business-icon-white.png" class="businessimgwhite" alt="TONE B2B"/>
                                                <p>FOR BUSINESS</p>
                                            </router-link>
                                            <router-link v-if="user && (user.corporation && user.corporation.enableCorporatePage === 1)" :to="{ path: '/corporation/mycommunity'}" class="logged">
                                                <!--<i class="nav-icon community-icon"></i>-->
                                                <i class="fa fa-suitcase fa-2x" style="font-size: 22px;margin: 0 0 8px;color: #8a8a8a;"></i>
                                                <p>MY COMPANY</p>
                                            </router-link>
                                        </li>
                                        <!--<li class="pointercursor">-->
                                        <!--<a @click="expertsClick()">-->
                                        <!--<i class="fa fa-user-o fa-2x" style="font-size: 22px;margin: 0 0 8px;color: #8a8a8a;"></i>-->
                                        <!--<p>EXPERTS</p>-->
                                        <!--</a>-->
                                        <!--</li>-->
                                    </ul>
                                    <ul class="nav navbar-nav navbar-right" :class="[isUserLoggedIn ? 'margin-default' : 'margin-minimum']">
                                        <li v-if="!isNativeAppNavigation && currentRoute.name !== 'B2b'" class="mid-icons mobile-responsive-hide"><router-link  :to="{ path: '/search'}" class="logged">
                                            <i class="nav-icon search-icon"></i>
                                        </router-link></li>
                                            <!--<li class="mid-icons mobile-responsive-hide"><a href="#/search" class="nav-icon search-icon"></a></li>-->
                                        <li v-if="!isUserLoggedIn"  class="mid-icons login-btn">
                                            <a  v-if="!isNativeApp" href="javascript:" class="btn btn-link" @click="getCorporateGiftInfo ? redeemGiftcode() : $router.push('/signup')" :style="{'border-width': '0px !important', 'border-style': 'solid !important', 'border-color': this.getCorpButtonColor + ' !important', 'color': '#FFFFFF'}">
                                                <span v-if="getCorporateGiftingCode && getCorporateClient && getCorporateGiftInfo">{{getCorporateGiftInfo.button_label_01}}</span>
                                                <span v-else>Join</span>
                                            </a>
                                            <!--<router-link to="/login">Login</router-link>-->
                                        </li>
                                        <li v-if="!isUserLoggedIn && !getCorporateGiftingCode" class="mid-icons login-btn">
                                            <a href="javascript:" class="btn btn-link" @click="openModal('login')" :style="{'border-width': '0px !important', 'border-style': 'solid !important', 'border-color': '#45BCA9' + ' !important', 'color': '#FFFFFF'}">
                                                Sign In
                                            </a>
                                            <!--<router-link to="/login">Login</router-link>-->
                                        </li>
                                        <li v-if="!isUserLoggedIn && !getCorporateGiftingCode" class="mid-icons sign-up-button">
                                            <a  @click="directToSignup" class="btn btn-success btn-lg">
                                                Start Your Free Trial
                                            </a>
                                            <!--<router-link to="/login">Login</router-link>-->
                                        </li>
                                        <!--<li v-if="!isUserLoggedIn && getCorporateGiftingCode && getCorporateClient" class="mid-icons sign-up-button">-->
                                            <!--<a  @click="redeemGiftcode()" class="btn btn-success btn-lg">-->
                                                <!--{{getCorporateClient.button_label_01}}-->
                                            <!--</a>-->
                                            <!--&lt;!&ndash;<router-link to="/login">Login</router-link>&ndash;&gt;-->
                                        <!--</li>-->
                                        <li  v-if="isUserLoggedIn" class="mid-icons login-btn"><a href="javascript:" v-on:click="logout"
                                                                                                  v-bind:style="[!isMobile ? {'border-width': '1px !important', 'border-style': 'solid !important', 'border-color': this.getCorpButtonColor + ' !important', 'color': getCorpHeadingColor} : {'border': '1px solid' + getCorpHeaderColor +' !important', 'color': getCorpHeadingColor, 'backgroundColor':'#fff'}]">Logout</a></li>
                                        <li v-if="isUserLoggedIn" class="userProfile">
                                            <span v-if="isUserLoggedIn.picture">
                                                <a  href="javascript:" class="logged" @click="gotoProfile()">
                                                    <span v-if="user && user.corporation && user.corporation.showShoeMotif === 2">
                                                         <img class="img-responsive img-circle" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-brd.png" alt="USER PROFILE" />
                                                    </span>
                                                    <span v-else>
                                                         <img class="img-responsive img-circle" v-bind:src="isUserLoggedIn.picture" alt="USER SHOE" />
                                                    </span>
                                                    <span class="usernamelimit" v-if="user.firstName">{{user.firstName.toLowerCase()}}</span>
                                            </a>
                                                <!--<router-link  :to="{ path: '/profile'}" class="toggleMenu">-->
                                                <!--<img class="img-responsive img-circle" v-bind:src="isUserLoggedIn.picture"/>-->
                                                <!--<span v-if="user.firstName">{{user.firstName.toLowerCase()}}</span>-->
                                                <!--</router-link>-->

                                                <!--<a href="#/profile"><img class="img-responsive img-circle" v-bind:src="isUserLoggedIn.picture"/></a>-->
                                            </span>
                                            <span v-else>
                                                 <router-link  :to="{ path: '/profile'}" class="logged">
                                              <img class="img-responsive img-circle" src="http://placekitten.com/g/200/200" alt="USER PROFILE"/>
                                              <span class="usernamelimit">{{user.firstName.toLowerCase()}}</span>
                                            </router-link>
                                                <!--<a href="#/profile"><img class="img-responsive img-circle" src="http://placekitten.com/g/200/200"/></a>-->
                                            </span>

                                        </li>
                                    </ul>
                                    <div  class="text-center unauth-links" v-if="!user">
                                        <a href="https://www.facebook.com/tonenetworks/" target="new">
                                            <i class="fa fa-facebook-square fa-2x"></i>
                                        </a>
                                        <a href="https://twitter.com/ToneNetworks" target="new">
                                            <i data-v-5cb853a2="" aria-hidden="true" class="fa fa-twitter-square fa-2x"></i>
                                        </a>
                                        <a href="https://www.instagram.com/tonenetworks/" target="new">
                                            <i data-v-5cb853a2="" aria-hidden="true" class="fa fa-instagram fa-2x"></i>
                                        </a>
                                        <a href="https://www.linkedin.com/company/25037986/" target="new">
                                            <i class="fa fa-linkedin-square fa-2x"></i>
                                        </a>
                                        <a href="https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos" target="new">
                                            <i class="fa fa-youtube-play fa-2x"></i>
                                        </a>
                                    </div>
                                </div>
                                <!--/.nav-collapse -->
                            </div>
                        </div>
                        <!--/.container-fluid -->
                    </nav>
                </div>
            </div>
            <div class="clearfix"></div>
            <!--v-if="getAlertMsgStatus && user"-->
            <div class="container-fluid" v-if="startMsgBoard && msgDuration > 10 && msgBoard && user && (currentRoute.name !== 'TrialExpiry' || currentRoute.name !== 'Rules' || currentRoute.name !== 'LiveEvent' || currentRoute.name !== 'Talk')">
                <div class="alert alert-info text-center alertmsg">
                    <span v-if="msgBoard[0].destinationURL && (msgBoard[0].destinationURL.indexOf('http') > -1 || msgBoard[0].destinationURL.indexOf('/') === 0)">
                         <a style="cursor:pointer;" @click="messageBoardRedirect(msgBoard[0])">{{msgBoard[0].bannerMessage}}</a>
                    </span>
                    <span v-else>
                        {{msgBoard[0].bannerMessage}}
                    </span>
                    <a title = 'close' class="close" @click="closeBanner()"><i class="fa fa-times"></i></a>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <modal class="loginModal"  v-if="showModal" effect="zoom" :value="showModal" @cancel="cancelModal()" width="400">
            <div slot="modal-header" class="loginHeaderModal">
                <a href="javascript:">
                    <img src="../../assets/logo.svg" alt="LOGO">
                </a>
                <a href="javascript:" @click="cancelModal()">
                    <img class="watchVideoArrow" src="../../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="bodyContent">
                    <div v-if="!isForget" class="login-modal">
                        <div>
                            <h2>Sign In</h2>
                        </div>
                        <div class="form">
                            <form id="login_form" v-on:submit.prevent="onSubmit">
                                <div class="padding-minus">
                                    <bs-input v-model="info.email"
                                              id="login_email"
                                              type="email"
                                              class="form-input"
                                              error="Email Address"
                                              placeholder="Email Address"
                                              required
                                              icon>
                                    </bs-input>
                                    <bs-input v-model="info.password"
                                              id="login_password"
                                              error="Password"
                                              type="password"
                                              class="form-input"
                                              placeholder="Password"
                                              required
                                              icon>
                                    </bs-input>
                                </div>
                                <checkbox v-model="isChecked" value="isChecked" type="primary">
                                    Remember me
                                </checkbox>
                                <div class="text-center">
                                    <button v-if="!spinner" class="gradient-tone-header btn formButton btn-transparent" id="login_button">
                                        Sign In
                                    </button>
                                    <spinner v-if="spinner" v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                </div>
                                <div class="text-center">
                                    <a href="javascript:" v-on:click="isForget = !isForget" class="forgotPassword" id="login_lnkforgotpassword"><strong style="font-size:16px;">Forget your password ?</strong></a>
                                    <br>
                                    <a href="javascript:" v-on:click="redirectSignup()" class="forgotPassword" id="login_redirectsingup"><strong style="font-size:16px;">Don't have an account? Subscribe here!</strong></a>
                                </div>
                            </form>
                            <!--<alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
                            <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                            <!--<strong>Error:</strong>-->
                            <!--<p id="login_errormsg">{{error.message}}</p>-->
                            <!--</alert>-->
                        </div>
                    </div>
                    <div v-if="isForget" class="forget-password-modal">
                        <div>
                            <h2 class="forgot-heading">
                                Forgot your password?
                            </h2>
                            <p>Enter your email address to reset your password. your may need</p>
                            <p>to check your spam folder to unblock</p>
                            <p>no-reply@tonenetworks.com.</p>
                        </div>
                        <div class="form">
                            <form id="forgot_password_form" v-on:submit.prevent="onSubmitForgetRequest">
                                <bs-input v-model="forgetPassword.email"
                                          id="forgot_password_email"
                                          type="email"
                                          class="form-input"
                                          error="Email Address"
                                          placeholder="Email Address"
                                          required
                                          icon>
                                </bs-input>
                                <div class="text-center">
                                    <button :disabled="spinner" class="btn formButton" id="forgot_password_proceed">
                                        Submit
                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                    </button>
                                </div>
                                <div class="text-center">
                                    <a href="javascript:" v-on:click="isForget = !isForget" class="forgotPassword" id="login_lnkbacktologin"><strong>Back to Sign In</strong></a>
                                </div>
                            </form>
                            <!--<h3 v-if="forgotPasswordSuccess">-->
                            <!--Forgot Password Request Sent! Check your email and follow the reset link-->
                            <!--</h3>-->
                            <!--<alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
                            <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                            <!--<strong>Error:</strong>-->
                            <!--<p id="forgotpassword_errormsg">{{error.message}}</p>-->
                            <!--</alert>-->
                        </div>
                    </div>
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
        <modal class="expiredmodal" v-if="showExpiryModal" :value="showExpiryModal" effect="zoom" @cancel="cancelExpiryModal()">
            <div class="modal-header"  slot="modal-header" >
                    <img src="../../assets/coloredlogotone.png" alt="LOGO">
                <a href="javascript:" @click="cancelExpiryModal()" class="close">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <h2>We don't want to lose you!</h2>
                <p><b>Your credit card on file is expiring in {{getCardExpiryDays}} <span v-if="getCardExpiryDays > 1">days.</span><span v-else>day.</span> Help us keep your information up to date.</b> </p>
                <div class="text-center small">
                    <button class="btn formButton btn-transparent"  @click="cancelExpiryModal();$router.push('/profile')">
                        Update Payment Info
                    </button><br>
                    <a href="javascript:" @click="cancelExpiryModal()">Not now, I'll update later</a><br>
                    If you have any questions please contact us at <a href="mailto:feedback@tonenetworks.com">feedback@tonenetworks.com</a><br>
                    For more information on our Terms of Services, <a href="javascript:" @click="cancelExpiryModal();$router.push('/terms')">click here</a>
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal class="expiredmodal"   v-if="showExpiredModal" :backdrop="false" :value="showExpiredModal" effect="zoom" @cancel="cancelExpiredModal()">
            <div class="modal-header" slot="modal-header">
                    <img class="expiryModalImage" src="../../assets/coloredlogotone.png" alt="LOGO">
                <!--<a  href="javascript:" @click="cancelExpiredModal()">-->
                    <!--<img class="watchVideoArrow" src="../../assets/watch-video-arrow.png" alt="">-->
                <!--</a>-->
            </div>
            <div slot="modal-body" class="modal-body">
                <h2>Whoops, your payment failed! </h2>
                <p><b>We were unable to verify your payment method on file. Don't worry, we'll try your payment again over the next five days. To keep Tone Networks access, you may need to update your payment details.</b> </p>
                <div class="text-center small">
                    <button class="btn formButton btn-transparent"  @click="cancelExpiredModal();$router.push('/profile')">
                        Update Payment Info
                    </button><br>
                    If you have any questions please contact us at <a href="mailto:feedback@tonenetworks.com">feedback@tonenetworks.com</a><br>
                    For more information on our Terms of Services, <a href="javascript:" @click="cancelExpiredModal();$router.push('/terms')">click here</a>
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </header>
</template>

<script>
    import {navbar, modal, input, spinner, alert, checkbox} from 'vue-strap'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import { dateHelpers } from '../../helpers/dateHelpers.js'
    // import store from '../../store'

    export default {
        components: {
            'navbar': navbar,
            'bs-input': input,
            'spinner': spinner,
            'alert': alert,
            modal: modal,
            checkbox: checkbox
        },
        props: ['hideNav'],
        name: 'header',
        data () {
            return {
                isMobile: false,
                headerConfig: {
                    isLoggedIn: false,
                    background: '#44bda8'
                },
                info: {
                    email: '',
                    password: ''
                },
                forgetPassword: {
                    email: ''
                },
                isNav: this.hideNav,
                showModal: false,
                spinner: false,
                isForget: false,
                isChecked: true,
                forgotPasswordSuccess: false,
                showExpertsModal: false,
                eventDescription: '',
                showEvent: false,
                authEventDescription: '',
                showAlertMsg: false,
                alertMsg: '',
                category: this.$route.params.contentCateogry,
                hideBanner: false,
                isNativeApp: false,
                isNativeAppNavigation: false,
                msgBoard: null,
                msgDuration: 0,
                startMsgBoard: true,
                intervalId: 0,
                expiryDateLimit: 265,
                showExpiryModal: false,
                showExpiredModal: false,
                showGiftIcon: true,
                customGiftMessage: '',
                customGiftUrl: '',
                showGiftingLinks: false
            }
        },
        beforeRouteUpdate (to, from, next) {
            this.category = to.params.contentCateogry
            next()
        },
        beforeDestroy () {
            clearInterval(window['intervalMsgBoard'])
        },
        watch: {
            'getGiftingLinksFlag' (to, from) {
                let self = this
                if (self.getGiftingLinksFlag) {
                    self.showGiftingLinks = false
                } else {
                    self.showGiftingLinks = true
                }
            },
            'getCardExpiryDays' (to, from) {
            },
            '$route' (to, from) {
                this.isNav = this.hideNav
            },
            'getLoginTriggerStatus' (to, from) {
                if (this.getLoginTriggerStatus && !this.user) {
                    this.openModal('login')
                }
            },
            'currentRoute.name' (to, from) {
                let self = this
                if (self.user && self.user.userId > 0) {
                    self.$store.dispatch('UPDATEUSERPAYLOAD', self.user.userId).then(() => {
                        if (self.getCardExpiryDays) {
                            if (self.getCardExpiryDays < 0 && self.user.ccExpiryDate && self.user.ccExpAlarmFlag === 2) {
                                if (this.currentRoute.name !== 'Profile' && this.currentRoute.name !== 'B2b' && this.currentRoute.name !== 'ToneResources' && this.currentRoute.name !== 'Terms' && this.currentRoute.name !== 'AboutUs' && this.currentRoute.name !== 'ContactUs' && this.currentRoute.name !== 'PressRelease' && this.currentRoute.name !== 'FAQ' && this.currentRoute.name !== 'PrivacyPolicy' && this.currentRoute.name !== 'Feedback') {
                                    self.showExpiredModal = true
                                    self.$router.next(false)
                                }
                            }
                        }
                    })
                }
                this.$store.dispatch('GETAPPCONFIGRATION')
                if (self.getSiteStatus) {
                    self.$router.push('/sitemaintenance')
                } else {
                    if (this.currentRoute.name === 'Player' || this.currentRoute.name === 'PlaylistVideoPlayer' || this.currentRoute.name === 'CorpPlaylistVideoPlayer' || this.currentRoute.name === 'ArchivePlayer') {
                        console.log('(inside Header.vue) dismiss video player activity')
                    } else {
                        console.log('log user navigation')
                        let userPayload = []
                        let uId = 0
                        if (self.user) {
                            uId = self.user.userId
                        }
                        userPayload.push(uId)
                        userPayload.push(self.currentRoute.fullPath)
                        console.log('user activity', userPayload)
                        self.$store.dispatch('LOGUSERACTIVITY', userPayload)
                    }
                    if (self.startMsgBoard && (self.user && self.user.userId > 0) && self.msgDuration > 10 && self.msgBoard) {
                        let removedItem = self.msgBoard.shift()
                        self.msgBoard.push(removedItem)
                    }
                    // console.log('=======================================> this.user.corporation.corporationId = ', this.user.corporation.corporationId)
                    // console.log('=======================================> this.currentRoute.name = ', this.currentRoute.name)
                    if (this.user && this.getAlertMsgStatus && this.getTrialDays < 0) {
                        if (this.user && (this.user.corporation && this.user.corporation.corporationId === 90)) { // If user belongs to NOVO Corporation, redirect it to differen tpage
                            this.$router.push('/become-member-novo')
                        } else {
                            if (this.currentRoute.name === 'Experts' || this.currentRoute.name === 'Expert' || this.currentRoute.name === 'Event' || this.currentRoute.name === 'ContactUs' || this.currentRoute.name === 'AboutUs' || this.currentRoute.name === 'Feedback' || this.currentRoute.name === 'Terms' || this.currentRoute.name === 'FAQ' || this.currentRoute.name === 'PrivacyPolicy' || this.currentRoute.name === 'Search' || this.currentRoute.name === 'Profile' || this.currentRoute.name === 'Gift' || this.currentRoute.name === 'Gifts' || this.currentRoute.name === 'Work' || this.currentRoute.name === 'Life' || this.currentRoute.name === 'Mindbody' || this.currentRoute.name === 'Money' || this.currentRoute.name === 'Player' || this.currentRoute.name === 'B2b' || this.currentRoute.name === 'Press') {
                            } else {
                                if (this.user && (this.user.corporation && this.user.corporation.corporationId === 90)) { // If user belongs to NOVO Corporation, redirect it to differen tpage
                                    this.$router.push('/become-member-novo')
                                } else {
                                    this.$router.push('/becomemember')
                                }
                            }
                        }  // FOLLOWING ELSE IF PART IS ADDED ON 03/31/2025
                    } else if (this.user && (this.user.corporation && this.user.corporation.corporationId === 200 && this.currentRoute.name === 'Hello')) {
                        // this.$router.push('/corporation/mycommunity')
                    }
                }
            }
        },
        methods: {
            handleCorporateGiftingStatus () {
                let self = this
                if (self.user && self.user.corporation && self.user.corporation.corporationId > 0 && self.user.corporation.giftIconState === '3') { // Custom Banner is provided
                    self.showGiftIcon = true
                    self.customGiftMessage = self.user.corporation.giftIconMessage
                    self.customGiftUrl = self.user.corporation.giftIconUrl
                } else if (self.user && self.user.corporation && self.user.corporation.corporationId > 0 && self.user.corporation.giftIconState === '2') { // Hide gifting Icons and message {
                    self.showGiftIcon = true
                    self.customGiftMessage = ''
                    self.customGiftUrl = ''
                } else { // Leave Gifting as it is
                    self.showGiftIcon = true
                    self.customGiftMessage = ''
                    self.customGiftUrl = ''
                }
            },
            cancelExpiryModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showExpiryModal = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            cancelExpiredModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showExpiredModal = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            logout: function (event) {
                $('#header-navbar').toggleClass('in')
                $('.navbar-toggle').toggleClass('collapsed active')
                this.$store.dispatch('LOGOUT', this.user)
            },
            initiateMessageBoard (interRef) {
                let removedItem = this.msgBoard.shift()
                this.msgBoard.push(removedItem)
            },
            closeBanner () {
                this.startMsgBoard = false
                clearInterval(window['intervalMsgBoard'])
            },
            corpBannerRedirect (cUrl) {
                let self = this
                if (cUrl) {
                    let url = cUrl.trim()
                    if (url.indexOf('http') > -1) { // URL is not from TONENetworks
                        window.open(url, 'toolbar=yes')
                    } else if (url.indexOf('/') === 0) { // URL is TONENetworks Resource
                        self.$router.push(url)
                    } else {
                    }
                } else {
                }
            },
            messageBoardRedirect (msg) {
                let self = this
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                userPayload.push(self.currentRoute.fullPath)
                userPayload.push('BLUE_BANNER_CLICK')
                userPayload.push(msg.bannerMessage)
                self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
                if (msg.destinationURL) {
                    let url = msg.destinationURL.trim()
                    if (url.indexOf('http') > -1) { // URL is not from TONENetworks
                        window.open(url, 'toolbar=yes')
                        let removedItem = self.msgBoard.shift()
                        self.msgBoard.push(removedItem)
                    } else if (url.indexOf('/') === 0) { // URL is TONENetworks Resource
                        self.$router.push(url)
                    } else {
                    }
                } else {
                }
            },
            redeemGiftcodeMobile () {
//                $('#header-navbar').toggleClass('in')
//                $('.navbar-toggle').toggleClass('collapsed active')
                console.log('10 inside header.vue [redeemGiftcodeMobile ()] ----------------> this.getCorporateClientId = ', this.getCorporateClientId)
                // console.log('20 inside header.vue ----------------> this.getCorporateClientId = ${this.getCorporateClientId}!')
                // 112 = COMCAST
                if (this.getCorporateClientId === '112' || this.getCorporateClientId === '197') {
                    this.$router.push(`/corporationgiftingcustom/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                } else if (this.getCorporateClientId === '200') {
                    // this.$router.push('/horizonsso/sso1data')
                    this.$router.push('/horizonsso?no_assertion_found=true')
                } else if (this.getCorporateClient.invitationCode === '2') {
                    this.$router.push(`/corporation/referral/buy/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                } else {
                    this.$router.push(`/corporationgifting/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                }
                this.checkAndToggleMenu()
                // this.$router.push(`/corporationgifting/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                // this.$router.push(`/redeem?params=${this.getCorporateGiftingCode}`)
            },
            redeemGiftcode () {
//                $('#header-navbar').toggleClass('in')
//                $('.navbar-toggle').toggleClass('collapsed active')
                console.log('10 inside header.vue [redeemGiftcode ()] ----------------> this.getCorporateClientId = ', this.getCorporateClientId)
                // 112 = COMCAST
                const corporateCorporationId = typeof this.getCorporateClientId === 'number' ? this.getCorporateClientId.toString() : this.getCorporateClientId
                // if (this.getCorporateClientId === '112' || this.getCorporateClientId === '197') {
                if (corporateCorporationId === '112' || corporateCorporationId === '197') {
                    this.$router.push(`/corporationgiftingcustom/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                // } else if (this.getCorporateClientId === '200') {
                } else if (corporateCorporationId === '200') {
                    // this.$router.push('/horizonsso/sso1data')
                    this.$router.push('/horizonsso?no_assertion_found=true')
                } else if (this.getCorporateClient.invitationCode === '2') {
                    this.$router.push(`/corporation/referral/buy/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                } else {
                    this.$router.push(`/corporationgifting/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                }
                // this.$router.push(`/corporationgifting/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                // this.$router.push(`/redeem?params=${this.getCorporateGiftingCode}`)
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'event') {
                    return monStr + ' ' + dayStr
                } else if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            redirectToFeedback () {
                this.$router.push('/feedback')
            },
            cancelModal () {
                $('html').removeClass('model-open')
                var self = this
                // var $ = window.jQuery
                setTimeout(function () {
                    self.showModal = false

                    /* to reset modal for login behaviour */
                    self.isForget = false

                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            cancelExpertsModal () {
                var self = this
                // var $ = window.jQuery
                setTimeout(function () {
                    self.showExpertsModal = false

                    /* to reset modal for login behaviour */
                    // self.isForget = false

                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            openModal (status) {
                window.logEvents('Unauthenticated Page', 'click', 'Login')
                let originalVideoCode = this.getOriginalVideoCode
                let originalVieoTitle = this.getOriginalVideoTitle
                if (this.currentRoute.name === 'SharePlayer') {
                    if (sessionStorage.getItem('redirectPath')) {
                        sessionStorage.removeItem('redirectPath')
                        sessionStorage.setItem('redirectPath', this.currentRoute.path)
                    } else {
                        sessionStorage.setItem('redirectPath', this.currentRoute.path)
                    }
                } else if (originalVideoCode && this.currentRoute.name === 'UnauthPlayer') {
                    let refBy = this.$route.params.refBy
                    if (refBy && (refBy.toLowerCase() === 'toneteaser' || refBy.toLowerCase() === 'tonetakeaway')) {
                        if (sessionStorage.getItem('redirectPath')) {
                            sessionStorage.removeItem('redirectPath')
                            if (originalVieoTitle) {
                                sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}/${refBy}/${originalVieoTitle}`)
                            } else {
                                sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}/${refBy}`)
                            }
                        } else {
                            if (originalVieoTitle) {
                                sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}/${refBy}/${originalVieoTitle}`)
                            } else {
                                sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}/${refBy}`)
                            }
                        }
                    } else {
                        if (sessionStorage.getItem('redirectPath')) {
                            sessionStorage.removeItem('redirectPath')
                            if (originalVieoTitle) {
                                sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}/${originalVieoTitle}`)
                            } else {
                                sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}`)
                            }
                        } else {
                            if (originalVieoTitle) {
                                sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}/${originalVieoTitle}`)
                            } else {
                                sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}`)
                            }
                        }
                    }
                }
                if (status === 'login') {
                    $('html').addClass('model-open')
                }
                $('#header-navbar').removeClass('in')
                $('.navbar-toggle').removeClass('collapsed active')
                let href = window.location.href
                // console.log('Header.vue : window.location.href = ', window.location.href) // Header.vue:955 Header.vue : window.location.href =  http://localhost:8085/horizonsso?no_assertion_found=true
                if (href.indexOf('?no_assertion_found=true') > -1) {
                    this.$router.push('/')
                }
                this.showModal = true
            },
            gotoProfile () {
                this.checkAndToggleMenu()
                this.$router.push('/profile')
            },
            joinEventFromBanner (eventId) {

            },
            checkAndToggleMenu () {
                setTimeout(() => {
                    if ($('#header-navbar').hasClass('in')) {
                        $('#header-navbar').toggleClass('in')
                        $('.navbar-toggle').toggleClass('collapsed active')
                    }
                }, 50)
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            logoClickRedirect () {
                let self = this
                if (self.user && self.currentRoute.name === 'Hello') {
                    window.location.reload()
                    return
                }
                self.checkAndToggleMenu()
                if (self.getMarketingPlan || self.getCorporateGiftingCode) {
                    if (self.getCorporateGiftingCode) {
                        if (self.getCorporateClient.invitationCode === '2') {
                            self.$router.push(`/corporation/referral/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                        } else {
                            self.$router.push(`/corporation/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                        }
                        // this.$router.push(`/corporation/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                    } else {
                        self.$router.push('/plan/' + this.getMarketingPlan)
                    }
                } else {
                    self.$router.push('/')
                }
            },
            directToSignup () {
                window.logEvents('Unauthenticated Page', 'click', 'Signup from Header')
                $('#header-navbar').toggleClass('in')
                $('.navbar-toggle').toggleClass('collapsed active')
                if (this.getMarketingPlan) {
                    this.$router.push('/signup/' + this.getMarketingPlan)
                } else {
                    this.$router.push('/signup')
                }
            },
            redirectToUnAuthenticatedPage (route) {
                var hash = route
                window.scrollTo(0, 0)
                this.$router.push('/')
                setTimeout(() => {
                    if ($(hash).length) {
                        $('body, html').animate({
                            scrollTop: $(hash).offset().top
                        }, 1000, function () {
                            // some other stuff
                            // console.info('done scrolling', $(hash).offset().top)
                        })
                    }
                }, 1000)
            },
            searchClick () {
                this.$router.push('/search')
                this.checkAndToggleMenu()
            },
            headerMenusClick (route) {
                window.logEvents('Feedback Page', 'Tell Us What you Think Link Clicked')
                this.$router.push(route)
                this.checkAndToggleMenu()
            },
            expertsClick () {
                $('#header-navbar').toggleClass('in')
                $('.navbar-toggle').toggleClass('collapsed active')
                // this.$router.push('/experts')
                if (!this.isUserLoggedIn) {
                    this.showExpertsModal = true
                } else {
                    this.$router.push('/experts')
                }
            },
            redirectSignup () {
                this.cancelModal()
                $('#header-navbar').toggleClass('in')
                $('.navbar-toggle').toggleClass('collapsed active')
                if (this.getMarketingPlan > 0) {
                    this.$router.push('/signup/' + this.getMarketingPlan)
                } else {
                    this.$router.push('/signup')
                }
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                // console.log('date returned', serverDate)
                return serverDate
            },
            isEventToday (evtDate) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            JoinEventOrRedirect () {
                // Get Event Details
                console.log('1 -> Header.vue -> JoinEventOrRedirect() -> ')
                if (this.getEventList) {
                    console.log('2 -> Header.vue -> JoinEventOrRedirect() -> this.getEventList = ', this.getEventList)
                    var ev = this.getEventList.filter(e => {
                        return e.eventId === this.getBannerEvent
                    })
                    console.log('3 -> Header.vue -> JoinEventOrRedirect() -> ev = ', ev)
                    if (ev && ev.length > 0) {
                        let eventDate = new Date(ev[0].start_date)
                        let eventEndDate = new Date(ev[0].end_date)
                        let currentDate = this.returnEasternTime()
                        console.log('4A -> Header.vue -> JoinEventOrRedirect() -> eventDate.getDate() = ', eventDate.getDate())
                        console.log('4B -> Header.vue -> JoinEventOrRedirect() -> currentDate = ', currentDate)
                        if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                            console.log('5 -> Header.vue -> JoinEventOrRedirect() -> ev = ', ev)
                            if (this.getMinutesBetweenDates(currentDate, eventDate) <= 60 && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                                console.log('6 -> Header.vue -> JoinEventOrRedirect() -> ev = ', ev)
                                this.$router.push('/events') // commented on 11/08/21
                                // this.$router.push(`/liveevent/` + ev[0].eventId) // reverted on 11/17/2021
                            } else {
                                console.log('7 -> Header.vue -> JoinEventOrRedirect() -> ev = ', ev)
                                this.$router.push('/events')
                            }
                        } else {
                            console.log('8 -> Header.vue -> JoinEventOrRedirect() ->')
                            this.$router.push('/events')
                        }
                        console.log('9 -> Header.vue -> JoinEventOrRedirect() ->')
                    }
                } else {
                    console.log('10 -> Header.vue -> JoinEventOrRedirect() ->')
                    this.$router.push('/events')
                }
                console.log('11 -> Header.vue -> JoinEventOrRedirect() ->')
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            onSubmit () {
                var self = this
                if (self.info.email && self.info.password) {
                    self.spinnerToggle()
                    const lowerCaseEmail = self.info.email.toLowerCase()
                    console.log('onSubmit () : ====================> lowerCaseEmail = ', lowerCaseEmail)
                    // if (lowerCaseEmail.includes('@horizonblue.com')) {
                    if (lowerCaseEmail.indexOf('@horizonblue.com') > -1) {
                        self.spinnerToggle()
                        self.cancelModal()
                        // self.$router.push('/horizonsso/sso1data')
                        self.$router.push('/horizonsso?no_assertion_found=true')
                    } else {
                        self.$store.dispatch('LOGIN', {user: self.info}).then(() => {
                            self.spinnerToggle()
                            if (!self.error.show) {
                                if ($(window).width() > 739) {
                                } else {
                                    let self = this
                                    var eventDesc
                                    this.$store.dispatch('GETEVENTLIST').then(() => {
                                        if (this.getEventList) {
                                            let currentDate = this.returnEasternTime()
                                            let eMonth = currentDate.getMonth() + 1
                                            eMonth = eMonth >= 10 ? eMonth : `0${eMonth}`
                                            let eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : `0${currentDate.getDate()}`
                                            let formattedDate = `${eMonth}/${eDate}/${currentDate.getFullYear()}`
                                            // Get Events on given Day
                                            let eventsOnDate = this.getEventList.filter(ev => {
                                                return ev.start_date.substr(0, 10) === formattedDate
                                            })
                                            // Get Events other than current Day
                                            let eventsNotOnDate = this.getEventList.filter(ev => {
                                                return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate)
                                            })
                                            if (eventsOnDate && eventsOnDate.length > 0) {
                                                if (this.isEventToday(eventsOnDate[0].end_date)) {
                                                    let eventTime = new Date(eventsOnDate[0].start_date)
                                                    let eventHrs = this.getHoursFormatted(eventTime)
                                                    this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(() => {})
                                                    if (eventsOnDate[0].type === '1') {
                                                        eventDesc = `Join us for TONE Live at ${eventHrs} ET`
                                                        this.eventDescription = eventsOnDate[0].unAuthBannerText
                                                    } else {
                                                        eventDesc = `Join us for TONE Talks at ${eventHrs} ET`
                                                        this.eventDescription = eventsOnDate[0].unAuthBannerText
                                                    }
                                                    if (self.currentRoute.name === 'Hello') {
                                                        if (self.user && self.user.corporation == null) { // Regular user
                                                            self.$swal({
                                                                background: '#44bda8',
                                                                title: '',
                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                text: '',
                                                                type: null,
                                                                timer: 5000,
                                                                showConfirmButton: true,
                                                                showCloseButton: true,
                                                                showCancelButton: false,
                                                                confirmButtonColor: '#f0617d',
                                                                confirmButtonText:
                                                                    'Find out more'
                                                            }).then(
                                                                function () {
                                                                    self.JoinEventOrRedirect()
                                                                },
                                                                // handling the promise rejection
                                                                function (dismiss) {
                                                                    if (dismiss === 'timer') {
                                                                    }
                                                                }
                                                            )
                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                            self.$swal({
                                                                background: '#44bda8',
                                                                title: '',
                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                text: '',
                                                                type: null,
                                                                timer: 5000,
                                                                showConfirmButton: true,
                                                                showCloseButton: true,
                                                                showCancelButton: false,
                                                                confirmButtonColor: '#f0617d',
                                                                confirmButtonText:
                                                                    'Find out more'
                                                            }).then(
                                                                function () {
                                                                    self.JoinEventOrRedirect()
                                                                },
                                                                // handling the promise rejection
                                                                function (dismiss) {
                                                                    if (dismiss === 'timer') {
                                                                    }
                                                                }
                                                            )
                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                            self.$swal({
                                                                background: '#44bda8',
                                                                title: '',
                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                                text: '',
                                                                type: null,
                                                                timer: 5000,
                                                                showConfirmButton: true,
                                                                showCloseButton: true,
                                                                showCancelButton: false,
                                                                confirmButtonColor: '#f0617d',
                                                                confirmButtonText:
                                                                    'Find out more'
                                                            }).then(
                                                                function () {
                                                                    self.$router.push('/corporation/mycommunity')
                                                                },
                                                                // handling the promise rejection
                                                                function (dismiss) {
                                                                    if (dismiss === 'timer') {
                                                                    }
                                                                }
                                                            )
                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                            self.$swal({
                                                                background: '#44bda8',
                                                                title: '',
                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                                text: '',
                                                                type: null,
                                                                timer: 5000,
                                                                showConfirmButton: true,
                                                                showCloseButton: true,
                                                                showCancelButton: false,
                                                                confirmButtonColor: '#f0617d',
                                                                confirmButtonText:
                                                                    'Find out more'
                                                            }).then(
                                                                function () {
                                                                    self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                                },
                                                                // handling the promise rejection
                                                                function (dismiss) {
                                                                    if (dismiss === 'timer') {
                                                                    }
                                                                }
                                                            )
                                                        }
                                                    } else {

                                                    }
                                                } else {
                                                    // Display next event in queue
                                                    if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                                        // let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                                        this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                                        if (eventsNotOnDate[0].type === '1') {
                                                            this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                            this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                        } else {
                                                            this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                            this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                        }
                                                        eventDesc = this.eventDescription
                                                        if (self.currentRoute.name === 'Hello') {
                                                            if (self.user && self.user.corporation == null) { // Regular user
                                                                self.$swal({
                                                                    background: '#44bda8',
                                                                    title: '',
                                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                    text: '',
                                                                    type: null,
                                                                    timer: 5000,
                                                                    showConfirmButton: true,
                                                                    showCloseButton: true,
                                                                    showCancelButton: false,
                                                                    confirmButtonColor: '#f0617d',
                                                                    confirmButtonText:
                                                                        'Find out more'
                                                                }).then(
                                                                    function () {
                                                                        self.JoinEventOrRedirect()
                                                                    },
                                                                    // handling the promise rejection
                                                                    function (dismiss) {
                                                                        if (dismiss === 'timer') {
                                                                        }
                                                                    }
                                                                )
                                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                                self.$swal({
                                                                    background: '#44bda8',
                                                                    title: '',
                                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                    text: '',
                                                                    type: null,
                                                                    timer: 5000,
                                                                    showConfirmButton: true,
                                                                    showCloseButton: true,
                                                                    showCancelButton: false,
                                                                    confirmButtonColor: '#f0617d',
                                                                    confirmButtonText:
                                                                        'Find out more'
                                                                }).then(
                                                                    function () {
                                                                        self.JoinEventOrRedirect()
                                                                    },
                                                                    // handling the promise rejection
                                                                    function (dismiss) {
                                                                        if (dismiss === 'timer') {
                                                                        }
                                                                    }
                                                                )
                                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                                self.$swal({
                                                                    background: '#44bda8',
                                                                    title: '',
                                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                                    text: '',
                                                                    type: null,
                                                                    timer: 5000,
                                                                    showConfirmButton: true,
                                                                    showCloseButton: true,
                                                                    showCancelButton: false,
                                                                    confirmButtonColor: '#f0617d',
                                                                    confirmButtonText:
                                                                        'Find out more'
                                                                }).then(
                                                                    function () {
                                                                        self.$router.push('/corporation/mycommunity')
                                                                    },
                                                                    // handling the promise rejection
                                                                    function (dismiss) {
                                                                        if (dismiss === 'timer') {
                                                                        }
                                                                    }
                                                                )
                                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                                self.$swal({
                                                                    background: '#44bda8',
                                                                    title: '',
                                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                                    text: '',
                                                                    type: null,
                                                                    timer: 5000,
                                                                    showConfirmButton: true,
                                                                    showCloseButton: true,
                                                                    showCancelButton: false,
                                                                    confirmButtonColor: '#f0617d',
                                                                    confirmButtonText:
                                                                        'Find out more'
                                                                }).then(
                                                                    function () {
                                                                        self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                                    },
                                                                    // handling the promise rejection
                                                                    function (dismiss) {
                                                                        if (dismiss === 'timer') {
                                                                        }
                                                                    }
                                                                )
                                                            }
                                                        } else {
                                                        }
                                                    }
                                                }
                                            } else {
                                                // Display other event in queue
                                                if (eventsNotOnDate && eventsNotOnDate.length > 0) {
//                                                let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                                    this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {
                                                    })
                                                    if (eventsNotOnDate[0].type === '1') {
                                                        this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                        this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                    } else {
                                                        this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                        this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                    }
                                                    eventDesc = this.eventDescription
                                                    if (self.currentRoute.name === 'Hello') {
                                                        if (self.user && self.user.corporation == null) { // Regular user
                                                            self.$swal({
                                                                background: '#44bda8',
                                                                title: '',
                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                text: '',
                                                                type: null,
                                                                timer: 5000,
                                                                showConfirmButton: true,
                                                                showCloseButton: true,
                                                                showCancelButton: false,
                                                                confirmButtonColor: '#f0617d',
                                                                confirmButtonText:
                                                                    'Find out more'
                                                            }).then(
                                                                function () {
                                                                    self.JoinEventOrRedirect()
                                                                },
                                                                // handling the promise rejection
                                                                function (dismiss) {
                                                                    if (dismiss === 'timer') {
                                                                    }
                                                                }
                                                            )
                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                            self.$swal({
                                                                background: '#44bda8',
                                                                title: '',
                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                text: '',
                                                                type: null,
                                                                timer: 5000,
                                                                showConfirmButton: true,
                                                                showCloseButton: true,
                                                                showCancelButton: false,
                                                                confirmButtonColor: '#f0617d',
                                                                confirmButtonText:
                                                                    'Find out more'
                                                            }).then(
                                                                function () {
                                                                    self.JoinEventOrRedirect()
                                                                },
                                                                // handling the promise rejection
                                                                function (dismiss) {
                                                                    if (dismiss === 'timer') {
                                                                    }
                                                                }
                                                            )
                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                            self.$swal({
                                                                background: '#44bda8',
                                                                title: '',
                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                                text: '',
                                                                type: null,
                                                                timer: 5000,
                                                                showConfirmButton: true,
                                                                showCloseButton: true,
                                                                showCancelButton: false,
                                                                confirmButtonColor: '#f0617d',
                                                                confirmButtonText:
                                                                    'Find out more'
                                                            }).then(
                                                                function () {
                                                                    self.$router.push('/corporation/mycommunity')
                                                                },
                                                                // handling the promise rejection
                                                                function (dismiss) {
                                                                    if (dismiss === 'timer') {
                                                                    }
                                                                }
                                                            )
                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                            self.$swal({
                                                                background: '#44bda8',
                                                                title: '',
                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                                text: '',
                                                                type: null,
                                                                timer: 5000,
                                                                showConfirmButton: true,
                                                                showCloseButton: true,
                                                                showCancelButton: false,
                                                                confirmButtonColor: '#f0617d',
                                                                confirmButtonText:
                                                                    'Find out more'
                                                            }).then(
                                                                function () {
                                                                    self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                                },
                                                                // handling the promise rejection
                                                                function (dismiss) {
                                                                    if (dismiss === 'timer') {
                                                                    }
                                                                }
                                                            )
                                                        }
                                                    } else {

                                                    }
                                                }
                                            }
                                        }
                                    })
                                }
                            }
                            if (self.error.show && self.error.originalMessage !== 'aws.cognito.UserNotConfirmed') {
                                self.$swal({
                                    title: self.error.message,
                                    text: '',
                                    type: 'error',
                                    timer: 2000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            } else if (self.error.show && self.error.originalMessage === 'aws.cognito.UserNotConfirmed') {
                                self.$swal({
                                    title: 'Validate Your Email Address',
                                    text: 'We have already sent you a validation email. Do you want us to resend it?',
                                    type: 'error',
                                    showCancelButton: true,
                                    confirmButtonText: 'Yes, Please',
                                    cancelButtonText: 'Cancel',
                                    confirmButtonClass: 'btn btn-success',
                                    cancelButtonClass: 'btn btn-danger',
                                    buttonsStyling: false
                                }).then(function (result) {
                                    self.$store.dispatch('RESENDVALIDATIONCODE', self.info.email).then(() => {
                                        self.$swal({
                                            title: 'Check your mailbox for new validation email',
                                            text: '',
                                            type: 'success',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(
                                            function () {
                                            },
                                            // handling the promise rejection
                                            function (dismiss) {
                                                if (dismiss === 'timer') {
                                                }
                                            }
                                        )
                                        self.cancelModal()
                                    })
                                }, function (dismiss) {
                                })
                            } else {
                                self.cancelModal()
                                // self.spinnerToggle()
                            }
//                    if (self.user !== null) {
//                        console.info('login success')
//                        self.cancelModal()
//                    }
//                    self.spinnerToggle()
                        })
                    }
                }
            },
            onSubmitForgetRequest: function () {
                var self = this
                this.spinnerToggle()
                if (self.forgetPassword && self.forgetPassword.email) {
                    self.spinnerToggle()
                    const lowerCaseEmail = self.forgetPassword.email.toLowerCase()
                    console.log('onSubmitForgetRequest () : ====================> lowerCaseEmail = ', lowerCaseEmail)
                    // if (lowerCaseEmail.includes('@horizonblue.com')) {
                    if (lowerCaseEmail.indexOf('@horizonblue.com') > -1) {
                        self.spinnerToggle()
                        self.cancelModal()
                        // self.$router.push('/horizonsso/sso1data')
                        self.$router.push('/horizonsso?no_assertion_found=true')
                    } else {
                        this.$store.dispatch('FORGOTPASSWORD', {user: this.forgetPassword}).then(() => {
                            this.spinnerToggle()
                            if (self.error.show) {
                                self.$swal({
                                    title: self.error.message,
                                    text: '',
                                    type: 'error',
                                    timer: 2000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            } else {
                                self.$swal({
                                    title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                                    text: '',
                                    type: 'success',
                                    timer: 3000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                                self.cancelModal()
                                // self.spinnerToggle()
                            }
//                if (!this.error.show) {
//                    this.forgotPasswordSuccess = true
//                    setTimeout(() => {
//                        this.forgotPasswordSuccess = false
//                        self.cancelModal()
//                    }, 3000)
//                }
                        })
                    }
                }
            },
            openTonePodPage () {
                window.open('https://www.podpage.com/have-you-had-this-conversation/', '_blank')
            }
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'isScrolled', 'error', 'getMarketingPlan', 'getAllExperts', 'getEventList', 'getBannerEvent', 'getLoginTriggerStatus', 'getAlertMsgStatus', 'getTrialDays', 'getCorporateGiftingCode', 'getCorporateClientId', 'getCorporateClient', 'getOriginalVideoCode', 'getOriginalVideoTitle', 'getMessageDuration', 'getMessageBoard', 'getSiteStatus', 'getGiftingText', 'getCardExpiryDays', 'getCustomUnauthBannerStatus', 'getCustomUnauthBannerText', 'getCustomUnauthBannerLink', 'getGiftingLinksFlag', 'getAuthLeftTopBannerMessage', 'getAuthLeftTopBannerUrl', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorporateGiftInfo'
            ]),
            currentRoute () {
                //  console.log('route', this.$route)
//            console.log('route', this.$route.name)
//            if (this.$route.name === 'Redeem,') {
//                console.log('yes')
//            }
                return this.$route
            }
        },
        mounted: function () {
            let self = this
            var $ = window.jQuery
            if ($(window).width() > 767) {
                self.isMobile = false
            } else {
                self.isMobile = true
            }
            console.log('(inside Header.vue) current route', self.currentRoute)
            clearInterval(window['intervalMsgBoard'])
//            })
            if (navigator.userAgent.indexOf('gonative') > -1) {
                this.isNativeApp = true
                this.isNativeAppNavigation = true
            }
            this.$store.dispatch('GETAPPCONFIGRATION').then(() => {
                if (self.getSiteStatus) {
                    self.$router.push('/sitemaintenance')
                }
//                console.log('configuration status', this.getSiteStatus)
                this.msgDuration = this.getMessageDuration * 1000
            })
            if (self.getGiftingLinksFlag) {
                self.showGiftingLinks = false
            } else {
                self.showGiftingLinks = true
            }
            let corpId = 0
            if (self.user && self.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId
                console.log('2-(inside Header.vue) corpId', corpId)
                // if (corpId === 200) {
                //     self.$router.push('/corporation/mycommunity')
                // }
            }
            this.$store.dispatch('GETMESSAGEBOARD', corpId).then(() => {
                this.msgBoard = this.getMessageBoard
            })
            setTimeout(() => {
                if (self.user && self.user.userId > 0 && self.msgDuration > 10) {
                    self.$store.dispatch('UPDATEUSERPAYLOAD', self.user.userId)
                    clearInterval(window['intervalMsgBoard'])
                    window['intervalMsgBoard'] = setInterval(() => {
                        self.initiateMessageBoard()
                    }, self.msgDuration)
                }
                if (self.user && self.user.userId > 0 && self.user.ccExpiryDate && self.user.ccExpAlarmFlag === 2) {
                    self.$store.dispatch('UPDATEUSERPAYLOAD', self.user.userId).then(() => {
                        if (self.getCardExpiryDays) {
                            if ((self.getCardExpiryDays) >= 0 && (self.getCardExpiryDays) <= 5) {
                                self.showExpiryModal = true
                            } else if (self.getCardExpiryDays < 0) {
                                if (this.currentRoute.name !== 'Profile') {
                                    self.showExpiredModal = true
                                }
                            }
                        }
                    })
                }
                // if (self.user.trialEndDate) {
                //     let endingDate = new Date(self.user.trialEndDate.substr(0, 10))
                //     let currentDate = new Date()
                //     let remainingDays = dateHelpers.getDatesDifference(endingDate, currentDate, 'days')
                //     store.commit('setHeaderAlertStatus', true)
                //     store.commit('setTrialDays', remainingDays)
                // }
                if (this.user && (this.user.corporation && this.user.corporation.corporationId === 90 && this.getTrialDays < 0)) { // If user belongs to NOVO Corporation, redirect it to different tpage
                    this.$router.push('/become-member-novo')
                }
            }, 1200)
            this.$store.dispatch('GETALLEXPERTS').then(() => {
            })
            $('.navbar-header .navbar-toggle').on('click', function () {
                $(this).toggleClass('active')
            })
            $('.userProfile>span>a').on('click', function () {
                $('#header-navbar').toggleClass('in')
                $('.navbar-toggle').toggleClass('collapsed active')
            })
//        $('#header-navbar a.btn.btn-link').on('click', function (e) {
//            $('#header-navbar').toggleClass('in')
//            $('.navbar-toggle').toggleClass('collapsed active')
//        })
            $('.toggleMenu').on('click', function () {
                self.checkAndToggleMenu()
            })
            $('#header-navbar ul.application-icons li').on('click', 'a.not-logged', function (e) {
                // prevent page from reloading behaviour, just to test pipeline
                e.preventDefault()

                // store hash
                var hash = this.hash
                // animate if not logged in
                if (!self.isUserLoggedIn) {
                    $('#header-navbar').toggleClass('in')
                    $('.navbar-toggle').toggleClass('collapsed active')
                    if (self.$route.name !== 'UnAuth') {
                        if (self.getCorporateGiftingCode || self.getCorporateClientId) {
                            window.scrollTo(0, 0)
                            self.$router.push(`/corporation/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                        } else {
                            window.scrollTo(0, 0)
                            self.$router.push('/')
                        }
                        setTimeout(() => {
                            if ($(hash).length) {
                                $('body, html').animate({
                                    scrollTop: $(hash).offset().top
                                }, 1000, function () {
                                    // some other stuff
                                })
                            }
                        }, 2000)
                    } else {
                        // if entire page has required selector then proceed
                        if ($(hash).length) {
                            $('body, html').animate({
                                scrollTop: $(hash).offset().top
                            }, 1000, function () {
                            })
                        }
                    }
                } else {
                    // if not logged in set url for desired page
                    window.location.hash = hash
                    $('#header-navbar').toggleClass('in')
                    $('.navbar-toggle').toggleClass('collapsed active')
                }
            })
            $('#header-navbar ul.application-icons li').on('click', 'a.logged', function (e) {
                $('#header-navbar').toggleClass('in')
                $('.navbar-toggle').toggleClass('collapsed active')
            })
//            if (this.user && this.getTrialDays < 0) {
//                this.$router.push('/becomemember')
//            }
            if ($(window).width() > 739) {
                this.$store.dispatch('GETEVENTLIST').then(() => {
                    if (this.getEventList) {
                        let currentDate = this.returnEasternTime()
                        let eMonth = currentDate.getMonth() + 1
                        eMonth = eMonth >= 10 ? eMonth : `0${eMonth}`
                        let eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : `0${currentDate.getDate()}`
                        let formattedDate = `${eMonth}/${eDate}/${currentDate.getFullYear()}`
                        // Get Events on given Day
                        let eventsOnDate = this.getEventList.filter(ev => {
                            return ev.start_date.substr(0, 10) === formattedDate
                        })
                        // Get Events other than current Day
                        let eventsNotOnDate = this.getEventList.filter(ev => {
                            return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate)
                        })
                        if (eventsOnDate && eventsOnDate.length > 0) {
                            // There is or was an event today
                            // If event is in progress or yet to be started
                            if (this.isEventToday(eventsOnDate[0].end_date)) {
                                // Verify if event is in progress or ended
//                                let eventTime = new Date(eventsOnDate[0].start_date)
//                                let eventHrs = this.getHoursFormatted(eventTime)
                                this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(() => {})
                                if (eventsOnDate[0].type === '1') {
                                    this.eventDescription = eventsOnDate[0].unAuthBannerText
                                    this.authEventDescription = eventsOnDate[0].authBannerText
                                } else {
                                    this.eventDescription = eventsOnDate[0].unAuthBannerText
                                    this.authEventDescription = eventsOnDate[0].authBannerText
                                }
                            } else {
                                // Display next event in queue
                                if (eventsNotOnDate && eventsNotOnDate.length > 0) {
//                                    let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                    this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                    if (eventsNotOnDate[0].type === '1') {
                                        this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                        this.authEventDescription = eventsNotOnDate[0].authBannerText
                                    } else {
                                        this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                        this.authEventDescription = eventsNotOnDate[0].authBannerText
                                    }
                                }
                            }
                        } else {
                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
//                                let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {
                                    this.showEvent = true
                                })
                                if (eventsNotOnDate[0].type === '1') {
                                    this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                    this.authEventDescription = eventsNotOnDate[0].authBannerText
                                } else {
                                    this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                    this.authEventDescription = eventsNotOnDate[0].authBannerText
                                }
                                // this.showEvent = true
                            }
                        }
                    }
                })
            } else {
                let eventDesc
                this.$store.dispatch('GETAPPCONFIGRATION').then(() => {
                    if (self.currentRoute.name === 'UnAuth' && self.getCustomUnauthBannerStatus) { // Check if Custom Banner is enabled
                        self.$swal({
                            background: '#44bda8',
                            title: '',
                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.getCustomUnauthBannerText + ' </span>',
                            text: '',
                            type: null,
                            timer: 5000,
                            showConfirmButton: true,
                            showCloseButton: true,
                            showCancelButton: false,
                            confirmButtonColor: '#f0617d',
                            confirmButtonText:
                                'Find out more'
                        }).then(
                            function () {
                                self.$router.push(self.getCustomUnauthBannerLink)
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    } else {
                        this.$store.dispatch('GETEVENTLIST').then(() => {
                            if (this.getEventList) {
                                let currentDate = this.returnEasternTime()
                                let eMonth = currentDate.getMonth() + 1
                                eMonth = eMonth >= 10 ? eMonth : `0${eMonth}`
                                let eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : `0${currentDate.getDate()}`
                                let formattedDate = `${eMonth}/${eDate}/${currentDate.getFullYear()}`
                                // Get Events on given Day
                                let eventsOnDate = this.getEventList.filter(ev => {
                                    return ev.start_date.substr(0, 10) === formattedDate
                                })
                                // Get Events other than current Day
                                let eventsNotOnDate = this.getEventList.filter(ev => {
                                    return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate)
                                })
                                if (eventsOnDate && eventsOnDate.length > 0) {
                                    if (this.isEventToday(eventsOnDate[0].end_date)) {
                                        let eventTime = new Date(eventsOnDate[0].start_date)
                                        let eventHrs = this.getHoursFormatted(eventTime)
                                        this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(() => {})
                                        if (eventsOnDate[0].type === '1') {
                                            eventDesc = `Join us for TONE Live at ${eventHrs} ET`
                                            this.eventDescription = eventDesc
                                        } else {
                                            eventDesc = `Join us for TONE Talks at ${eventHrs} ET`
                                            this.eventDescription = eventDesc
                                        }
                                        if (self.currentRoute.name === 'UnAuth') {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText:
                                                    'Find out more'
                                            }).then(
                                                function () {
                                                    self.$router.push('/event')
                                                },
                                                // handling the promise rejection
                                                function (dismiss) {
                                                    if (dismiss === 'timer') {
                                                    }
                                                }
                                            )
                                        } else if (self.currentRoute.name === 'Hello') {
                                            if (self.user && self.user.corporation == null) { // Regular user
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.JoinEventOrRedirect()
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.JoinEventOrRedirect()
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.$router.push('/corporation/mycommunity')
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            }
                                        } else {
                                        }
                                    } else {
                                        // Display next event in queue
                                        if (eventsNotOnDate && eventsNotOnDate.length > 0) {
//                                    let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                            this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                            if (eventsNotOnDate[0].type === '1') {
                                                this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                this.authEventDescription = eventsNotOnDate[0].authBannerText
                                            } else {
                                                this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                this.authEventDescription = eventsNotOnDate[0].authBannerText
                                            }
                                            eventDesc = this.eventDescription
                                            if (self.currentRoute.name === 'UnAuth') {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.$router.push('/event')
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else if (self.currentRoute.name === 'Hello') {
                                                if (self.user && self.user.corporation == null) { // Regular user
                                                    self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText:
                                                            'Find out more'
                                                    }).then(
                                                        function () {
                                                            self.JoinEventOrRedirect()
                                                        },
                                                        // handling the promise rejection
                                                        function (dismiss) {
                                                            if (dismiss === 'timer') {
                                                            }
                                                        }
                                                    )
                                                } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                    self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText:
                                                            'Find out more'
                                                    }).then(
                                                        function () {
                                                            self.JoinEventOrRedirect()
                                                        },
                                                        // handling the promise rejection
                                                        function (dismiss) {
                                                            if (dismiss === 'timer') {
                                                            }
                                                        }
                                                    )
                                                } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                    self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText:
                                                            'Find out more'
                                                    }).then(
                                                        function () {
                                                            self.$router.push('/corporation/mycommunity')
                                                        },
                                                        // handling the promise rejection
                                                        function (dismiss) {
                                                            if (dismiss === 'timer') {
                                                            }
                                                        }
                                                    )
                                                } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                    self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText:
                                                            'Find out more'
                                                    }).then(
                                                        function () {
                                                            self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                        },
                                                        // handling the promise rejection
                                                        function (dismiss) {
                                                            if (dismiss === 'timer') {
                                                            }
                                                        }
                                                    )
                                                }
                                            } else {

                                            }
                                        }
                                    }
                                } else {
                                    // Display other event in queue
                                    if (eventsNotOnDate && eventsNotOnDate.length > 0) {
//                                let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                        this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                        if (eventsNotOnDate[0].type === '1') {
                                            this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                            this.authEventDescription = eventsNotOnDate[0].authBannerText
                                        } else {
                                            this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                            this.authEventDescription = eventsNotOnDate[0].authBannerText
                                        }
                                        eventDesc = this.eventDescription
                                        if (self.currentRoute.name === 'UnAuth') {
                                            self.$swal({
                                                background: '#44bda8',
                                                title: '',
                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                text: '',
                                                type: null,
                                                timer: 5000,
                                                showConfirmButton: true,
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                confirmButtonColor: '#f0617d',
                                                confirmButtonText:
                                                    'Find out more'
                                            }).then(
                                                function () {
                                                    self.$router.push('/event')
                                                },
                                                // handling the promise rejection
                                                function (dismiss) {
                                                    if (dismiss === 'timer') {
                                                    }
                                                }
                                            )
                                        } else if (self.currentRoute.name === 'Hello') {
                                            if (self.user && self.user.corporation == null) { // Regular user
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.JoinEventOrRedirect()
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.JoinEventOrRedirect()
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.$router.push('/corporation/mycommunity')
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                self.$swal({
                                                    background: '#44bda8',
                                                    title: '',
                                                    html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                    text: '',
                                                    type: null,
                                                    timer: 5000,
                                                    showConfirmButton: true,
                                                    showCloseButton: true,
                                                    showCancelButton: false,
                                                    confirmButtonColor: '#f0617d',
                                                    confirmButtonText:
                                                        'Find out more'
                                                }).then(
                                                    function () {
                                                        self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            }
                                        } else {

                                        }
                                    }
                                }
                            }
                        })
                    }
                })
            }
            console.log('inside Header.vue : clearing SEARCH SESSION STORAGE ------------')
            sessionStorage.removeItem('searchQry')
            sessionStorage.removeItem('currTabName')
            sessionStorage.removeItem('videoTabCurPageNum')
            sessionStorage.removeItem('eventTabCurPageNum')
            sessionStorage.removeItem('plistTabCurPageNum')
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .gradient-tone-header {
        /* TT-1039- REBRANDING */
        background: linear-gradient(
                to right,
                #44bda8 0%,
                #3aa9a7 30%,
                #2f8f9f 60%,
                #004573 100%
        ) !important;
    }
    .default-min-height {
        min-height: 87px;
    }
    .static-min-height {
        min-height: 50px!important;
    }
    @media(min-width:768px){
        header .nav-container .navbar-nav li
        {
            /* margin:0 0 0 8px; commented on 08/03/2021 */
            margin:0 0 0 1px;
        }
    }
    header .nav-container .navbar-nav li a i
    {
        max-width: 25px;
    }
    .pointercursor{cursor: pointer}
    header .nav-container #header-navbar .navbar-right .login-btn a {
        border: 1px solid #f0617d;
        border-radius: 4px;
    }
    @media(min-width:768px){
        header .nav-container .mobile-loginLogoutholder{
            display: none;
        }
    }
    header .nav-container .mobile-loginLogoutholder {
        position: absolute;
        z-index: 1;
        top: 14px;
        right:60px
    }
    header .nav-container .mobile-loginLogoutholder a i {
        color: #fff;
        width: auto;
        font-size: 25px;
    }
    .unauth-header header .nav-container .navbar-header a.nav-icon.navbar-toggle.search-icon.fa.fa-search {
        background: none;
        padding: 0;
        height: 26px;
        position: relative;
        left: -8px;
        top: 3px;
        text-decoration:none;
    }

    .unauth-header header .nav-container .navbar-header a.nav-icon.navbar-toggle.search-icon.fa.fa-search:before {
        font-size: 25px !important;
    }
    header .nav-container .mobile-loginLogoutholder a {
        padding: 5px;
    }
    header .nav-container .mobile-loginLogoutholder a i {
        clear: both;
        display: block;
    }

    header .nav-container .mobile-loginLogoutholder a {
        color: #fff;
        font-size: 10px;
        line-height: 7px;
    }
    /*.search-icon {*/
    /*-webkit-filter: brightness(100);*/
    /*filter: brightness(200);*/
    /*}*/
    .watchVideoModalHeader {
        text-align: center;
    }
    .watchVideoModalHeader {
        text-align: center;
    }
    .watchVideoModal .modal-dialog .modal-body {
        padding: 15px;
    }
    .watchVideoModal .modal-dialog .modal-body h2{
        color: #f0617d;
        text-transform: capitalize;
        margin: 40px 0 60px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        text-align:center;
    }
    .watchVideoModal .modal-dialog .modal-body .col-sm-5.text-left h2 small{
        color: #f0617d;
    }
    .watchVideoModal .modal-dialog .modal-body .row.expertsrow {
        margin: 0 -15px 20px;
    }
    .watchVideoModal .modal-dialog .modal-body .col-sm-5.text-left h2{
        color: #000000;
        font-size: 30px;
        font-family: sans-serif;
        margin: 30px 0 15px 0;
        text-align: left;
        text-transform: capitalize;
        letter-spacing: 0.3px;
    }
    .watchVideoModal .modal-dialog .modal-body .col-sm-5.text-left p{
        padding: 0;
    }
    .watchVideoModal .modal-dialog .modal-body button {
        background: #44bda8;
        color: white;
        font-size: 16px;
        border: none;
        width: 253px;
        padding: 14px 15px 12px;
        letter-spacing: 0.3px;
        text-transform: capitalize;
        border-radius: 3px;
        margin-bottom: 7px;
        margin: 30px auto 10px;
        display: block;
    }
    .notificationtext a {
        color: inherit;
        text-decoration: underline;
    }
    .notificationtext {
        left: 50%;
        color: #fff;
        position: absolute;
        font-weight: bold;
        z-index: 500;
        top: 43px;
        text-align: center;
        font-size: 18px;
        right: 20px;
        padding-left: 110px;
    }
    img.aboutimg {
        height: 27px;
        width: 27px;
        opacity: 0.5;
        margin: 0 0 3px;
    }
    img.aboutuswhite{display:none}
    @media(max-width:767px){
        img.aboutuswhite {
            height: 27px;
            width: 27px;
            opacity: 1;
            margin: 0 0 3px;
            display:inline-block;
        }

        img.aboutimg {
            display: none;
        }
        .search-icon {
            -webkit-filter: brightness(100);
            filter: brightness(200);
        }
    }
    @media(min-width:768px){
        .watchVideoModal .modal-dialog .modal-body .row.expertsrow .col-sm-3.col-sm-offset-2 {
            width: 41.66667%;
            margin-left: 0;
        }
        .watchVideoModal .modal-dialog .modal-body .col-sm-5.text-left {width:58.33333%}

        header .nav-container #header-navbar .navbar-right .userProfile a span.usernamelimit {
            max-width: 65px;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            position: absolute;
            top: 72px;
            left: 0;
            right: 0;
        }

    }
    /*header style for smaller devices and tabs */
    @media(min-width:1024px) and (max-width:1199px){
        header .nav-container .navbar .margin-left{margin-left:0 !important}

        .nav > li > a {
            padding: 20px 2px;
            letter-spacing: 0;
        }
        header .nav-container .navbar .margin-left li a p{
            letter-spacing: 0;
            font-size:14px;
        }
        .unauth-header header .nav-container #header-navbar .navbar-right .login-btn a{
            font-size:18px;
        }

    }
    @media(min-width:1200px){
        header .nav-container .navbar .margin-left{margin-left:1% !important}
    }
    @media(min-width:924px) and (max-width:1023px){
        header .nav-container .container {
            width: 100%;
        }

        .nav > li > a {
            padding: 20px 2px;
            letter-spacing: 0;
        }

        #header-navbar .navbar-left a p {
            font-size:14px;
            letter-spacing: 0px !important;
        }
        body header .nav-container #header-navbar .navbar-right .login-btn a {
            padding: 8px 2px !important;
            margin-left: 0 !important;
        }
    }

    @media(max-width:1050px) and (min-width:980px){
        body header .nav-container #header-navbar .navbar-right li.mid-icons {
            top: 30px;
            margin: 0 0px !important;
        }
    }
    @media(min-width:876px) and (max-width:923px){
        header .nav-container .container {
            width: 100%;
        }

        .nav > li > a {
            padding: 20px 2px;
            letter-spacing: 0;
        }

        #header-navbar .navbar-left a p {
            font-size:14px;
            letter-spacing: 0px !important;
        }
        .unauth-header header .nav-container #header-navbar .navbar-right .login-btn a{
            font-size:14px !important;
        }
    }
    @media(min-width:820px) and (max-width:875px){
        header .nav-container .container {
            width: 100%;
        }

        .nav > li > a {
            padding: 20px 2px;
            letter-spacing: 0;
        }

        #header-navbar .navbar-left a p {
            font-size:12px;
            letter-spacing: 0px !important;
        }
        header .nav-container #header-navbar .navbar-right .login-btn a {
            border: 0px solid #f0617d;
            border-radius: 4px;
            font-size: 14px !important;
            margin: 0 2px !important;
        }
    }
    @media(min-width:768px) and (max-width:819px){
        header .nav-container .container {
            width: 100%;
        }
        .nav > li > a {
            padding: 20px 2px;
            letter-spacing: 0;
        }
        #header-navbar .navbar-left a p {
            font-size:12px;
            letter-spacing: 0px !important;
            text-transform: lowercase;
        }

    }
    a.giftslink {
        position: absolute;
        left: 10px;
        top: 5px;
        color: #fff;
        z-index: 50;
        font-size: 120px;
        line-height: 24px;
    }
    i.fa.fa-gift span {
        margin-top: 2px;
        /*content: "Give the gift of TONE";*/
        display: block;
        color: #ffffff;
        font-size: 19px;
        text-align: center;
        font-family: "Quicksand", sans-serif;
        font-weight: bold;
        position: absolute;
        left: 110px;
        top: 40px;
        right: -150px;
        line-height: 1.3;
    }
    i.fa.fa-gift {
        text-align: center;
    }
    a.giftslink i {
        color: #ffffff;
    }
    .alertmsg{
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 1px;
        margin: 10px 0;
    }
    @media(max-width:767px){
        .notificationtext{
            display:none;
        }
        .giftslink {
            top: 1px !important;
            left: 54px !important;
        }

        i.fa.fa-gift {
            font-size: 28px;
        }


        i.fa.fa-gift span {
            display:none;
        }

        i.fa.fa-gift:after {
            margin-top:2px;
            content: "Gifting";
            /*content: "Gift with Purchase";*/
            display: block;
            color: #ffffff;
            font-size: 10px;
            line-height: 7px;
            position:static;
            text-align: center;
            font-family: "Quicksand", sans-serif;
            font-weight: bold;
        }
    }
    @media(max-width:767px){
        header .nav-container #header-navbar .navbar-right .userProfile span{color:#fff !important}
        header .nav-container #header-navbar .navbar-left li a i {
            color: #fff !important;
            text-shadow: 0 0 0 transparent !important;
            filter: brightness(100);
            -webkit-filter:brightness(100);
        }

        header .nav-container .navbar-nav li {
            margin: 0;
        }

        header .nav-container #header-navbar .navbar-left li{
            position:relative;
        }

        header .nav-container #header-navbar .navbar-left li a{
            position:static;
        }

        .nav > li > a:hover {
            background: none;
        }
        .nav > li > a:focus {
            background: none;
        }

        header .nav-container #header-navbar .navbar-left li a.router-link-active:before {
            background: rgba(0, 0, 0, 0.4);
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            display: block;
        }

    }


    header .nav-container a.about-link {
        position: absolute;
        top: -27px;
        color: #f0617d;
        margin: 0 auto;
        left: 50%;
        transform: translateX(-50%);
        text-transform: uppercase;
        letter-spacing: 3px;
        font-size: 12px;
        font-weight: bold;
        background: #fff;
        border-radius: 50px;
        padding: 2px 20px;
    }

    @media(max-width:767px){
        body header .nav-container a.about-link {
            top: 0px !important;
            z-index: 500;
            border-radius: 0px 0px 0px 50px !important;
            left: auto !important;
            transform: translateY(0) !important;
            right: 0;
            padding: 0px 20px !important;
        }
        header .nav-container #header-navbar .navbar-left li a i {
            max-width: 10000px;
            width: 25px !important;
            margin-right: 5px !important;
        }
    }
    @media(min-width:768px) and (max-width:1200px) {
        header .nav-container .navbar-nav li {
            margin-left: 0px !important;
        }
    }
    .loginModal .modal-dialog .modal-body .bodyContent .form form a {
        float: none;
    }
    @media(min-width: 1920px){
        header .nav-container .container {
            width: 1301px;
        }
    }
    @import url('https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700');

    header .nav-container .alertmsg{
        font-weight:500
    }
    header .nav-container .navbar-nav li a i.fa-newspaper-o {
        max-width: none;
        width: auto;
        margin:0 0 2px;
        height: 28px;
    }
    header .nav-container .alertmsg a {
        font-size: inherit;
        padding: 0;
        color: inherit;
        text-decoration: underline;
        font-weight: 900;
    }
    .unauth-header img.businessimg {
        display: none;
    }
    .unauth-header img.playlistsimg {
        display: none;
    }

    img.businessimgwhite{
        display:none
    }
    img.playlistswhite{
        display:none
    }
    .unauth-header img.businessimgwhite{
        display:inline;
    }
    .unauth-header img.playlistswhite{
        display:inline;
    }
    img.businessimg {
        height: 30px;
        width:30px;
        object-fit:contain;
    }
    img.playlistsimg {
        height: 30px;
        width:30px;
        object-fit:contain;
    }

    img.businessimgwhite {
        height: 30px;
        width:30px;
        object-fit:contain;
    }
    img.playlistswhite {
        height: 30px;
        width:30px;
        object-fit:contain;
    }
    @media(max-width:767px){
        img.businessimgwhite {
            display: none;
        }
        img.playlistswhite {
            display: none;
        }

        img.businessimgwhite {
            height: 30px;
            width:27px;
            object-fit:contain;
            display:inline;
        }

        img.playlistswhite {
            height: 30px;
            width:27px;
            object-fit:contain;
            display:inline;
        }
        img.businessimg{
            display:none;
        }
        img.playlistsimg{
            display:none;
        }
        .unauth-header img.businessimgwhite{
            display:none;
        }
        .unauth-header img.playlistswhite{
            display:none;
        }
        .unauth-header img.businessimg{
            height: 30px;
            width:27px;
            object-fit:contain;
            display:inline;
        }
        .unauth-header img.playlistsimg{
            height: 30px;
            width:27px;
            object-fit:contain;
            display:inline;
        }
    }
    header .nav-container .navbar-nav li a i.fa-newspaper-o {
        color:#999999;
    }
    .expiredmodal.modal .modal-header {
        text-align: center;
        padding: 40px 20px 0px;
    }

    .expiredmodal.modal h2 {
        font-weight: 900;
        color: #000;
        font-size: 32px;
        text-align: center;
    }

    .expiredmodal.modal p {
        text-align: center;
    }
    .expiredmodal.modal .modal-header {
        border-bottom: 0;
    }

    .expiredmodal.modal  .modal-body {
        padding: 0 60px 30px;
    }

    .expiredmodal.modal
    button.btn.formButton.btn-transparent {
        background: #f0617d;
        padding: 8px 25px;
        border-radius: 50px;
        outline: 0 none transparent;
        margin: 20px 0;
        color:#ffffff;
    }
    .expiredmodal {
        z-index: 5000;
    }
    .modal-content a.close {
        /* color: #333; */
        opacity: 1;
        top: 10px !important;
        position: absolute;
        right: 18px;
    }

    .modal-content a.close:after {
        content: "x";
        color: #000;
        opacity: 1;
        font-size: 30px;
    }

    @media(min-width:768px){
        ul.nav.application-icons.navbar-nav.navbar-left.margin-left {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            flex: 1 1 auto;
        }

        div#header-navbar {
            display: flex !important;
        }

        ul.nav.navbar-nav.navbar-right.margin-minimum {
            flex: 0 0 auto;
        }
    }

    .unauth-header i.nav-icon.podcasticon {
        background: url("https://s3.amazonaws.com/assets.tonenetworks.com/images/headphones-w.svg") no-repeat center center transparent !important;
    }
    i.nav-icon.podcasticon {
        background: url("https://s3.amazonaws.com/assets.tonenetworks.com/images/headphones.svg") no-repeat center center transparent !important;
    }
    @media(max-width:767px){
        i.nav-icon.podcasticon {
            background: url("https://s3.amazonaws.com/assets.tonenetworks.com/images/headphones.svg") no-repeat center center transparent !important;
        }
    }
    @media(max-width:767px){
        .unauth-header i.nav-icon.podcasticon {
            background: url(https://s3.amazonaws.com/assets.tonenetworks.com/images/headphones.svg) no-repeat center center transparent !important;
        }
    }
</style>
<style>
    .row.padding30 {
        margin: 0 -15px !important;
    }
    .logo {
        z-index: 5000;
        position: relative;
    }
    .row.padding30 > div {
        padding: 0;
    }
    .jw-icon.jw-icon-tooltip.jw-icon-cc.jw-reset.jw-toggle:after {
        content: "CC/Subtitles";
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background: #000;
        z-index: 3000;
        /* border: 1px solid #fff; */
        white-space: nowrap;
        top: -6px;
        font-family: arial;
        font-size: 12px;
        display: none;
        line-height: 1.3;
        padding: 1px 3px 0;
        border-radius: 2px;
    }
    /*.jw-icon.jw-icon-tooltip.jw-icon-cc.jw-reset.jw-toggle:hover:after {*/
    /*    display: block;*/
    /*}*/
    /*.jw-icon-rewind {*/
    /*    display: none !important;*/
    /*}*/
    a.btn.pink.btn-primary.headerlink {
        border: 2px solid #44bda8;
        background-color: #44bda8;
    }

    a.btn.pink.btn-primary.headerlink:hover {
        color: #fff;
        background-color: #3fa996;
        border-color: #3fa996;
    }
    a.btn.btn-success.btn-lg:hover {
        color: #fff;
        background-color: #449d44;
        border-color: #398439;
    }
    .unauth-header .notificationtext {
        display: block;
        width: auto;
        max-width: none;
        top: 90px;
        background: #fff;
        color: #000;
        left: 0;
        right: 0;
    }
    .unauth-header .notificationtext {
        display: block;
        width: auto;
        max-width: none;
        padding: 10px;
        top: 90px;
        background: #fff;
        color: #000;
        left: 0;
        right: 0;
    }

    .notificationtext a.close {
        text-decoration: none;
    }
    @media(min-width:768px){
    .unauth-header header .nav-container .navbar .margin-left li a i.nav-icon.career-icon{
    background:url(../../assets/Nav/work-w.svg) no-repeat center center transparent;
    }
    .unauth-header header .nav-container .navbar .margin-left li a i.nav-icon.inspiration-icon{
        background:url(../../assets/Nav/life-w.svg) no-repeat center center transparent;
    }
    .unauth-header header .nav-container .navbar .margin-left li a i.mind-body-icon{
        background:url(../../assets/Nav/mind_body-w.svg) no-repeat center center transparent;
    }
    .unauth-header header .nav-container .navbar .margin-left li a i.money-icon{
        background:url(../../assets/Nav/money-w.svg) no-repeat center center transparent;
    }
    .unauth-header header .nav-container .navbar .margin-left li a i.mind-body-icon{
        background:url(../../assets/Nav/mind_body-w.svg) no-repeat center center transparent;
    }
    .unauth-header header .nav-container #header-navbar .navbar-right li.mid-icons a i.search-icon{
        background:url(../../assets/Nav/search-w.svg) no-repeat center center transparent;
    }
    }
    .unauth-header .unauth-links {
        display: none;
    }
    @media(max-width:767px) {
        .unauth-header .notificationtext {
            display: none;
        }
        .unauth-header .unauth-links {
            display: block;
            background: #fff;
        }

        .unauth-header .unauth-links a , .unauth-header .unauth-links a i {
            display: inline-block;
            width: auto !important;
            padding: 0;
        }

        .unauth-header .unauth-links a {
            margin: 0 10px;
            padding: 15px 0 20px;
        }

        .unauth-header .unauth-links a i {
            font-size: 18px;
        }

        .unauth-header header .nav-container .navbar .margin-left {
            margin-bottom: 0;
        }

    }
    @media (max-width: 767px) and (min-width: 320px) {
        body{
            zoom: 1 !important;
        }
    }
    .alert.alert-primary.text-center.alertmsg {
        background: #44bda8;
        color: #fff;
    }

    .alert.alert-primary.text-center.alertmsg a {
        text-decoration: none;
        cursor:pointer;
        text-decoration: underline;
    }
    .alert.alert-primary.text-center.alertmsg a.close {
        padding: 0 2px;
        top: -1px;
        right: -1px;
        position: absolute;
        opacity:1;
        color:#fff;
    }

    .alert.alert-primary.text-center.alertmsg {
        position: relative;
    }

    .alert.alert-primary.text-center.alertmsg i.fa.fa-times {
        width: auto;
    }
    @media(max-width:419px){
     html body .unauth-header header .nav-container .mobile-loginLogoutholder a.btn.btn-link {
        font-size: 14px;
        padding: 8px 6px 1px;
    }
    }
    @media(min-width:1200px) and (max-width:1310px){
        .unauth-header header .logo {
            padding-right: 0;
        }

        body header .nav-container #header-navbar .navbar-right .login-btn a {
            padding: 5px !important;
        }
    }
    /*.expiryModalImage {*/
        /*display: block;*/
        /*margin-left: auto;*/
        /*margin-right: auto;*/
        /*z-index: 100000000;*/
    /*}*/

    .cust-corp-banner {
        position: absolute;
        top: 45px;
        left: 20px;
        font-size: 17px;
        font-weight: 900;
        color: #fff;
        right: calc( 50% + 130px);
        text-align: center;
    }
    .cust-corp-banner a{color:inherit;text-decoration:underline;}
    @media(max-width:767px){
        .cust-corp-banner{display:none;}
    }
</style>
<style>
    body > img {
        display:none;
    }
    @media(min-width:290px) and (max-width:767px){
        header .nav-container #header-navbar .navbar-left li a{
            min-width:200px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// Header.vue?2bb6a263